import React, { useEffect, useMemo, useRef, useState } from "react";
import quickpayMiniImg from "../images/APS_QPMINI.webp";
import e200Img from "../images/E200_SUNMI.webp";
import e300Img from "../images/E300_SUNMI.webp";
import e100Img from "../images/E100_SUNMI.webp";
import aps101Img from "../images/APS_101.webp";
import aps301Img from "../images/APS_301.webp";

const PRODUCTOS = [
  { id: 1, nombre: "Café Americano", precio: 45, emoji: "☕" },
  { id: 2, nombre: "Capuchino", precio: 65, emoji: "🥛" },
  { id: 3, nombre: "Latte", precio: 60, emoji: "🫖" },
  { id: 4, nombre: "Croissant", precio: 50, emoji: "🥐" },
  { id: 5, nombre: "Muffin", precio: 48, emoji: "🧁" },
  { id: 6, nombre: "Sandwich", precio: 95, emoji: "🥪" },
  { id: 7, nombre: "Agua", precio: 25, emoji: "💧" },
  { id: 8, nombre: "Jugo", precio: 40, emoji: "🧃" },
];

const DISPOSITIVOS = [
  { key: "tablet-horizontal", label: "Tablet horizontal", icon: "▭" },
  { key: "tablet-vertical", label: "Tablet vertical", icon: "▯" },
  { key: "movil-vertical", label: "Móvil vertical", icon: "▯" },
];

const MODELOS_CAJERO = [
  { key: "E100", label: "E100", image: e100Img, simKey: "e100" },
  { key: "E200", label: "E200", image: e200Img, simKey: "e200" },
  { key: "E300", label: "E300", image: e300Img, simKey: "e300" },
  { key: "QuickPay Mini", label: "QuickPay Mini", image: quickpayMiniImg, simKey: "quickpayMini" },
  { key: "APS101", label: "APS101", image: aps101Img, simKey: "aps101" },
  { key: "APS301", label: "APS301", image: aps301Img, simKey: "aps301" },
];

const money = (value) =>
  Number(value || 0).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
  });

const generarFolio = () =>
  `V${String(Math.floor(100000 + Math.random() * 900000))}`;

const MiniQR = ({ value = "" }) => {
  const size = 21;
  const seed = Array.from(value).reduce((acc, c) => acc + c.charCodeAt(0), 0);
  const cells = [];

  for (let y = 0; y < size; y += 1) {
    for (let x = 0; x < size; x += 1) {
      const tl = x < 7 && y < 7;
      const tr = x >= size - 7 && y < 7;
      const bl = x < 7 && y >= size - 7;
      const finder = tl || tr || bl;
      let fill = false;

      if (finder) {
        const lx = tr ? x - (size - 7) : x;
        const ly = bl ? y - (size - 7) : y;
        fill =
          lx === 0 ||
          ly === 0 ||
          lx === 6 ||
          ly === 6 ||
          (lx >= 2 && lx <= 4 && ly >= 2 && ly <= 4);
      } else {
        fill = ((x * 17 + y * 31 + seed) % 7) < 3;
      }

      if (fill) {
        cells.push(
          <rect
            key={`${x}-${y}`}
            x={x}
            y={y}
            width="1"
            height="1"
            fill="#111827"
          />
        );
      }
    }
  }

  return (
    <div className="ep-qr-wrap">
      <svg viewBox={`0 0 ${size} ${size}`} className="ep-qr-svg">
        <rect width={size} height={size} fill="#fff" />
        {cells}
      </svg>
    </div>
  );
};

const SelectorDispositivo = ({ value, onChange, soloMovil = false }) => {
  const opciones = soloMovil
    ? DISPOSITIVOS.filter((item) => item.key === "movil-vertical")
    : DISPOSITIVOS;

  return (
    <div className={`ep-device-selector ${soloMovil ? "mobile-only" : ""}`}>
      <div className="ep-device-selector-label">1. Dispositivo</div>
      <div className="ep-device-options">
        {opciones.map((item) => (
          <button
            type="button"
            key={item.key}
            className={`ep-device-option ${value === item.key ? "active" : ""}`}
            onClick={() => onChange(item.key)}
            disabled={soloMovil}
          >
            <span className={`ep-device-icon ${item.key}`}>{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const ProductGrid = ({ onAdd }) => (
  <div className="ep-products">
    {PRODUCTOS.map((item) => (
      <button
        type="button"
        className="ep-product"
        key={item.id}
        onClick={() => onAdd(item)}
      >
        <span className="ep-product-emoji">{item.emoji}</span>
        <strong>{item.nombre}</strong>
        <small>{money(item.precio)}</small>
      </button>
    ))}
  </div>
);

const Carrito = ({ carrito, total, onQty, onRemove, onAction, conectado, flujo, vertical = false, abierto = false, onClose }) => (
  <aside className={`ep-cart ${vertical ? "bottom-sheet" : ""} ${abierto ? "open" : ""}`}>
    {vertical && <div className="ep-sheet-handle" />}
    <div className="ep-cart-title">
      <strong>Carrito</strong>
      <div className="ep-cart-title-actions">
        <span>{carrito.reduce((acc, item) => acc + item.qty, 0)} productos</span>
        {vertical && (
          <button type="button" className="ep-sheet-close" onClick={onClose} aria-label="Cerrar carrito">×</button>
        )}
      </div>
    </div>

    <div className="ep-cart-items">
      {carrito.length === 0 ? (
        <div className="ep-empty compact">Selecciona productos.</div>
      ) : (
        carrito.map((item) => (
          <div className="ep-cart-item" key={item.id}>
            <div>
              <strong>{item.nombre}</strong>
              <small>{money(item.precio)}</small>
            </div>
            <div className="ep-qty">
              <button type="button" onClick={() => onQty(item.id, -1)}>−</button>
              <span>{item.qty}</span>
              <button type="button" onClick={() => onQty(item.id, 1)}>+</button>
              <button type="button" className="remove" onClick={() => onRemove(item.id)}>×</button>
            </div>
          </div>
        ))
      )}
    </div>

    <div className="ep-cart-total">
      <span>Total</span>
      <strong>{money(total)}</strong>
    </div>

    <button
      type="button"
      className="ep-primary full"
      onClick={onAction}
      disabled={total <= 0}
    >
      {!conectado
        ? `Registrar venta ${money(total)}`
        : flujo === "QR"
        ? `Generar venta ${money(total)}`
        : `Enviar al cajero ${money(total)}`}
    </button>
  </aside>
);

const PosScreen = ({ carrito, total, onAdd, onQty, onRemove, onAction, conectado, flujo, dispositivo, carritoAbierto, setCarritoAbierto }) => {
  const vertical = dispositivo !== "tablet-horizontal";
  const cantidad = carrito.reduce((acc, item) => acc + item.qty, 0);

  return (
    <div className={`ep-pos-screen ${vertical ? "vertical-pos" : ""}`}>
      <section className="ep-catalog">
        <div className="ep-search">Buscar producto…</div>
        <div className="ep-categories">
          <span className="active">Todos</span>
          <span>Cafetería</span>
          <span>Bebidas</span>
          <span>Snacks</span>
        </div>
        <ProductGrid onAdd={onAdd} />
      </section>

      {vertical && carritoAbierto && (
        <button type="button" className="ep-sheet-backdrop" onClick={() => setCarritoAbierto(false)} aria-label="Cerrar carrito" />
      )}

      <Carrito
        carrito={carrito}
        total={total}
        onQty={onQty}
        onRemove={onRemove}
        onAction={onAction}
        conectado={conectado}
        flujo={flujo}
        vertical={vertical}
        abierto={carritoAbierto}
        onClose={() => setCarritoAbierto(false)}
      />

      {vertical && (
        <button type="button" className="ep-cart-trigger" onClick={() => setCarritoAbierto(true)}>
          <span>Carrito {cantidad > 0 ? `· ${cantidad}` : ""}</span>
          <strong>{money(total)}</strong>
        </button>
      )}
    </div>
  );
};

const Calculadora = ({ monto, setMonto, onAction }) => {
  const press = (key) => {
    if (key === "back") {
      setMonto((prev) => prev.slice(0, -1));
      return;
    }
    if (monto.length >= 9) return;
    setMonto((prev) => `${prev}${key}`);
  };

  const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "back"];
  const valor = Math.trunc(Number(monto || 0));

  return (
    <div className="ep-calc-screen">
      <div className="ep-calc-main">
        <div className="ep-calc-label">Monto a cobrar</div>
        <div className="ep-calc-display">{money(valor)}</div>
        <div className="ep-keypad">
          {keys.map((key) => (
            <button
              type="button"
              key={key}
              className={key === "0" ? "zero" : key === "back" ? "back" : ""}
              onClick={() => press(key)}
            >
              {key === "back" ? "⌫" : key}
            </button>
          ))}
        </div>
      </div>

      <div className="ep-calc-side">
        <div>
          <h3>Cobro rápido</h3>
          <p>Captura un monto entero y envíalo directamente al cajero.</p>
        </div>
        <button
          type="button"
          className="ep-primary full"
          disabled={valor <= 0}
          onClick={onAction}
        >
          {`Enviar al cajero ${money(valor)}`}
        </button>
      </div>
    </div>
  );
};

const DeviceShell = ({
  dispositivo,
  conectado,
  setConectado,
  modo,
  setModo,
  flujo,
  carrito,
  total,
  onAdd,
  onQty,
  onRemove,
  onActionPos,
  montoCalc,
  setMontoCalc,
  onActionCalc,
  carritoAbierto,
  setCarritoAbierto,
}) => {
  const cls = {
    "tablet-horizontal": "tablet-h",
    "tablet-vertical": "tablet-v",
    "movil-vertical": "mobile-v",
  }[dispositivo];

  return (
    <div className={`ep-device-shell ${cls}`}>
      <div className="ep-device-toolbar">
        <strong>Empática POS</strong>
      </div>

      <div className="ep-device-screen">
        {modo === "POS" ? (
          <PosScreen
            carrito={carrito}
            total={total}
            onAdd={onAdd}
            onQty={onQty}
            onRemove={onRemove}
            onAction={onActionPos}
            conectado={conectado}
            flujo={flujo}
            dispositivo={dispositivo}
            carritoAbierto={carritoAbierto}
            setCarritoAbierto={setCarritoAbierto}
          />
        ) : (
          <Calculadora
            monto={montoCalc}
            setMonto={setMontoCalc}
            onAction={onActionCalc}
          />
        )}
      </div>
    </div>
  );
};

const Ticket = ({ operacion, qr }) => {
  if (!operacion) {
    return <div className="ep-empty">Genera una venta para mostrar el ticket.</div>;
  }

  if (qr) {
    return (
      <div className="ep-ticket-paper compact-qr">
        <div className="ep-ticket-center ep-ticket-brand">EMPÁTICA POS</div>
        <div className="ep-ticket-line" />
        <div className="ep-ticket-row"><span>Folio</span><strong>{operacion.folio}</strong></div>
        <div className="ep-ticket-row"><span>Fecha</span><strong>{operacion.fecha}</strong></div>
        <div className="ep-ticket-line" />
        <MiniQR value={operacion.qrPayload} />
      </div>
    );
  }

  return (
    <div className="ep-ticket-paper">
      <div className="ep-ticket-center ep-ticket-brand">EMPÁTICA POS</div>
      <div className="ep-ticket-center">Sucursal Demo</div>
      <div className="ep-ticket-line" />
      <div className="ep-ticket-row"><span>Folio</span><strong>{operacion.folio}</strong></div>
      <div className="ep-ticket-row"><span>Fecha</span><strong>{operacion.fecha}</strong></div>
      <div className="ep-ticket-row"><span>Modo</span><strong>{operacion.tipo}</strong></div>
      <div className="ep-ticket-line" />
      {operacion.items.map((item, index) => (
        <div className="ep-ticket-item" key={`${item.nombre}-${index}`}>
          <span>{item.nombre} x {item.qty}</span>
          <strong>{money(item.precio * item.qty)}</strong>
        </div>
      ))}
      <div className="ep-ticket-line" />
      <div className="ep-ticket-row total"><span>TOTAL</span><strong>{money(operacion.total)}</strong></div>
      <div className="ep-ticket-line" />
      <div className="ep-ticket-paid">VENTA PAGADA</div>
    </div>
  );
};



/* ============================================================
 * SIMULADOR DE CAJERO EMBEBIDO
 * Basado directamente en SimuladorCajero.js, pero recibe el monto
 * de la venta de EcosistemaPos y NO depende del componente externo.
 * ============================================================ */
const EmbeddedCashierSimulator = (() => {
  const embeddedEmpaticaLogo = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
/*
 * ============================================================
 * SIMULADOR DE CAJEROS
 * ============================================================
 *
 * Modelos:
 * - QuickPay Mini
 * - E200 + SUNMI
 * - E300 + SUNMI
 * - E100 + SUNMI
 * - APS101
 * - APS301
 *
 * No requiere librerías adicionales.
 *
 * IMPORTANTE E200:
 * La interfaz de la SUNMI se dibuja DENTRO del cristal real de
 * la pantalla. No cambia ni agranda la imagen del equipo.
 *
 * Referencias visuales utilizadas para la SUNMI:
 * - PantallaQP.js: pantalla de espera / escaneo
 * - Pago.js: Total a pagar / Ingresado / Restante
 * - MensajeFinal.js: Pago exitoso / Folio / Monto
 * ============================================================
 */

const ESTADOS = {
  ESPERANDO: "ESPERANDO",
  ESCANEANDO: "ESCANEANDO",
  CUENTA_CARGADA: "CUENTA_CARGADA",
  RECIBIENDO: "RECIBIENDO",
  PROCESANDO: "PROCESANDO",
  ENTREGANDO_CAMBIO: "ENTREGANDO_CAMBIO",
  PAGADO: "PAGADO",
  CANCELADO: "CANCELADO",
};

const BILLETES = [20, 50, 100, 200, 500];
const MONEDAS = [1, 2, 5, 10];

const generarMontoDemo = () => {
  // Monto aleatorio entre $120 y $950, en múltiplos de $10.
  const min = 12;
  const max = 95;
  return (Math.floor(Math.random() * (max - min + 1)) + min) * 10;
};

const generarFolioDemo = () => {
  return String(Math.floor(100000 + Math.random() * 900000));
};

/*
 * ============================================================
 * CONFIGURACIÓN DE MODELOS
 * ============================================================
 *
 * Las posiciones del E200 son DEFAULT iniciales.
 * El modo calibración sigue disponible para ajustarlas exactamente.
 */
const MODELOS = {
  quickpayMini: {
    key: "quickpayMini",
    label: "QuickPay Mini",
    image: quickpayMiniImg,
    viewW: 1086,
    viewH: 1448,
    storageKey: "simulador_quickpaymini_cal_v5",
    zonas: {
      display: {
        x: 567.8860136620895,
        y: 278.19480853240935,
        width: 241,
        height: 71,
      },
      scanner: {
        x: 341.0412950766429,
        y: 277.61597483000105,
        width: 80,
        height: 72,
      },
      billetero: {
        x: 284.2897768596362,
        y: 575.8943489533203,
        width: 188.03829963954655,
        height: 62.79013579576747,
      },
      monedero: {
        x: 687.2162550114739,
        y: 65.6099337961929,
        width: 56,
        height: 61,
      },
      ticket: {
        x: 288.73888797193047,
        y: 1096.5516695422714,
        width: 158,
        height: 24,
      },
      cambioMonedas: {
        x: 570.8320883403704,
        y: 1147.8655231909065,
        width: 213.2659954530692,
        height: 113.02143509590974,
      },
    },
  },

  e200: {
    key: "e200",
    label: "E200",
    image: e200Img,
    viewW: 1024,
    viewH: 1536,
    storageKey: "simulador_e200_cal_v3",
    zonas: {
      display: {
        x: 292.01826873306345,
        y: 169.97706282350555,
        width: 414.9771640836708,
        height: 222.93577590581543,
      },
      scanner: {
        x: 276.0685077489876,
        y: 95.99541256470111,
        width: 40.01370154979753,
        height: 38,
      },
      sunmiTicket: {
        x: 418.0319702828608,
        y: 103.05504922358672,
        width: 160,
        height: 16,
      },
      billetero: {
        x: 294.9314922510124,
        y: 615.8761392469298,
        width: 147.1781201473678,
        height: 54.05046178828775,
      },
      cambioBilletes: {
        x: 274.9771640836708,
        y: 798.7660407997564,
        width: 174.10504521511433,
        height: 61.10092357657584,
      },
      monedero: {
        x: 680.1187467649119,
        y: 436.9724753882067,
        width: 82,
        height: 30,
      },
      cambioMonedas: {
        x: 446.01826873306334,
        y: 1153.7385161879633,
        width: 190.10504521511405,
        height: 66.1926722825533,
      },
    },
  },

  e300: {
    key: "e300",
    label: "E300",
    image: e300Img,
    viewW: 1122,
    viewH: 1402,
    storageKey: "simulador_e300_cal_v2",
    zonas: {
      display: {
        x: 667.2910958904112,
        y: 104.57066883182787,
        width: 225.78767123287662,
        height: 132.2506647721506,
      },
      scanner: {
        x: 647.7636986301371,
        y: 58.64266720795696,
        width: 30.157534246575324,
        height: 26.178666396021498,
      },
      sunmiTicket: {
        x: 725.7636986301369,
        y: 61.3306404140871,
        width: 110,
        height: 14,
      },
      billetero: {
        x: 695.7636986301369,
        y: 403.2133360397848,
        width: 157.31506849315065,
        height: 81.07199837612916,
      },
      cambioBilletes: {
        x: 697.6849315068492,
        y: 468.7813457830102,
        width: 153.47260273972597,
        height: 61.037328732365836,
      },
      monedero: {
        x: 215.345890410959,
        y: 250.46400081193548,
        width: 142.38698630136986,
        height: 26.714665584086106,
      },
      cambioMonedas: {
        x: 234.95205479452054,
        y: 492.2853344159139,
        width: 143.52054794520546,
        height: 58.005318177204686,
      },
    },
  },

  e100: {
    key: "e100",
    label: "E100",
    image: e100Img,
    viewW: 1024,
    viewH: 1536,
    storageKey: "simulador_e100_cal_v6",
    zonas: {
      display: {
        x: 326.66737164560254,
        y: 210.89921145182012,
        width: 361.14483372143366,
        height: 202.23793238872298,
      },
      scanner: {
        x: 302.4673716456025,
        y: 144.20212162263533,
        width: 46.00456718326586,
        height: 38.01376230589668,
      },
      sunmiTicket: {
        x: 434.00456718326575,
        y: 154.3992463120921,
        width: 154,
        height: 18,
      },
      billetero: {
        x: 294.87062268579496,
        y: 717.4084211826897,
        width: 165.44936158720867,
        height: 47.75748017597823,
      },
      monedero: {
        x: 587.3382530060671,
        y: 473.80355927790697,
        width: 116.24461436425474,
        height: 30.6270453933696,
      },
      cambioMonedas: {
        x: 475.20325104019264,
        y: 1070.2759998058414,
        width: 190.63916975227335,
        height: 79.2207458333146,
      },
    },
  },

  aps101: {
    key: "aps101",
    label: "APS101",
    image: aps101Img,
    viewW: 1086,
    viewH: 1448,
    storageKey: "simulador_aps101_cal_v3",
    zonas: {
      /*
       * Pantalla táctil integrada del APS101.
       * Aquí se muestran las mismas interfaces de pago.
       */
      /*
       * Área útil REAL de la pantalla vertical del APS101.
       * Es únicamente el cristal interior, sin incluir el marco negro.
       */
      display: {
        x: 368.4927536231884,
        y: 117.19710144927541,
        width: 222.4927536231885,
        height: 352.29565217391297,
      },

      /*
       * Lector / escáner QR frontal inferior derecho.
       */
      scanner: {
        x: 589,
        y: 641.295652173913,
        width: 140.16811594202898,
        height: 94.29565217391303,
      },

      /*
       * Billetero frontal.
       * En APS101 recibe billetes y POR AQUÍ MISMO
       * devuelve el cambio de billetes.
       */
      billetero: {
        x: 366.40869565217395,
        y: 541.9855072463769,
        width: 93.49275362318843,
        height: 31.09855072463779,
      },

      /*
       * Salida de ticket.
       */
      ticket: {
        x: 572.6753623188406,
        y: 1031.0463768115942,
        width: 63.68985507246373,
        height: 22.098550724637562,
      },

      /*
       * Entrada de monedas.
       */
      monedero: {
        x: 539.2695652173913,
        y: 542.5304347826087,
        width: 53.73333333333312,
        height: 19.9768115942029,
      },

      /*
       * Bandeja de cambio de monedas.
       */
      cambioMonedas: {
        x: 389,
        y: 948.1971014492754,
        width: 173.66376811594193,
        height: 137.08405797101454,
      },
    },
  },


  aps301: {
    key: "aps301",
    label: "APS301",
    image: aps301Img,
    viewW: 1086,
    viewH: 1448,
    storageKey: "simulador_aps301_cal_v2",
    zonas: {
      /*
       * Pantalla vertical integrada del APS301.
       * Usa la misma interfaz vertical de pago del APS101.
       * Coordenadas iniciales aproximadas y calibrables.
       */
      display: {
        x: 339.4927536231885,
        y: 113.09855072463768,
        width: 237.09855072463756,
        height: 365,
      },

      /*
       * Scanner QR frontal inferior derecho.
       */
      scanner: {
        x: 634.2811594202899,
        y: 633.3797101449276,
        width: 99.2115942028986,
        height: 92.40869565217395,
      },

      /*
       * Entrada / salida de billetes.
       * En APS301 usamos el mismo punto para recibir
       * y devolver cambio de billetes.
       */
      billetero: {
        x: 354.59130434782605,
        y: 548.591304347826,
        width: 109,
        height: 91,
      },

      /*
       * Salida de ticket en el módulo inferior.
       */
      ticket: {
        x: 617.0840579710144,
        y: 1057.478260869565,
        width: 79.31014492753627,
        height: 17.90144927536221,
      },

      /*
       * Entrada de monedas en el lateral derecho superior.
       */
      monedero: {
        x: 550.8608695652176,
        y: 552.6144927536233,
        width: 17.649275362318917,
        height: 44.81739130434778,
      },

      /*
       * Bandeja inferior de cambio / devolución.
       */
      cambioMonedas: {
        x: 505.8869565217391,
        y: 1032.1391304347826,
        width: 84.18550724637669,
        height: 69.04347826086928,
      },
    },
  },
};

/*
 * Orden comercial / visual de las pestañas.
 */
const ORDEN_MODELOS = [
  "e100",
  "e200",
  "e300",
  "quickpayMini",
  "aps101",
  "aps301",
];

const clamp = (value, min, max) =>
  Math.min(Math.max(value, min), max);

/*
 * ============================================================
 * PANTALLA SUNMI
 * ============================================================
 *
 * IMPORTANTE:
 * Este componente trabaja siempre en 800 x 385.
 * Después se escala y se RECORTA al área calibrada del display.
 */
const SunmiScreen = ({
  estado,
  montoCuenta,
  montoIngresado,
  restante,
  cambio,
  folio,
}) => {
  const W = 800;
  const H = 385;

  const esPago =
    estado === ESTADOS.CUENTA_CARGADA ||
    estado === ESTADOS.RECIBIENDO ||
    estado === ESTADOS.PROCESANDO ||
    estado === ESTADOS.ENTREGANDO_CAMBIO;

  const esFinal = estado === ESTADOS.PAGADO;
  const esEscaneando = estado === ESTADOS.ESCANEANDO;

  return (
    <g>
      {/* Fondo real de la aplicación */}
      <rect x="0" y="0" width={W} height={H} fill="#FFFFFF" />

      {/* =====================================================
          ESPERA / ESCANEO
          Basado visualmente en PantallaQP.js
      ===================================================== */}
      {!esPago && !esFinal && (
        <>
          <rect
            x="24"
            y="22"
            width="752"
            height="341"
            rx="26"
            fill="#FFFFFF"
            stroke="#3B73B1"
            strokeWidth="2"
          />

          {/* QR ilustrado */}
          <g transform="translate(92 72)">
            <rect
              x="0"
              y="0"
              width="146"
              height="146"
              rx="22"
              fill="#F5F7FA"
            />

            <g fill="#17375E">
              <rect x="20" y="20" width="42" height="42" rx="3" />
              <rect x="84" y="20" width="42" height="42" rx="3" />
              <rect x="20" y="84" width="42" height="42" rx="3" />

              <rect x="29" y="29" width="24" height="24" fill="#FFFFFF" />
              <rect x="93" y="29" width="24" height="24" fill="#FFFFFF" />
              <rect x="29" y="93" width="24" height="24" fill="#FFFFFF" />

              <rect x="82" y="82" width="14" height="14" />
              <rect x="103" y="82" width="23" height="13" />
              <rect x="82" y="104" width="15" height="22" />
              <rect x="105" y="104" width="21" height="21" />
            </g>

            {esEscaneando && (
              <rect
                x="13"
                y="16"
                width="120"
                height="5"
                rx="2.5"
                fill="#23C5FF"
                opacity=".95"
              >
                <animate
                  attributeName="y"
                  values="16;126;16"
                  dur="1.05s"
                  repeatCount="indefinite"
                />
              </rect>
            )}
          </g>

          <text
            x="290"
            y="115"
            fill="#111827"
            fontSize="31"
            fontWeight="900"
          >
            {esEscaneando
              ? "Leyendo tu código..."
              : "Acerca tu código al lector"}
          </text>

          <text
            x="290"
            y="157"
            fill="#667085"
            fontSize="18"
            fontWeight="600"
          >
            Escanea el código QR para continuar con tu pago.
          </text>

          <rect
            x="290"
            y="194"
            width="405"
            height="68"
            rx="17"
            fill="#F5F7FA"
            stroke="#3B73B1"
            strokeWidth="2"
          />

          <text
            x="492.5"
            y="236"
            textAnchor="middle"
            fill="#3B73B1"
            fontSize="20"
            fontWeight="900"
          >
            {esEscaneando ? "Procesando..." : "Escanea tu código"}
          </text>
        </>
      )}

      {/* =====================================================
          PAGO EN EFECTIVO
          Basado visualmente en Pago.js
      ===================================================== */}
      {esPago && (
        <>
          <rect
            x="24"
            y="18"
            width="752"
            height="349"
            rx="20"
            fill="#FFFFFF"
          />

          <rect
            x="42"
            y="34"
            width="716"
            height="151"
            rx="18"
            fill="#FAFAFA"
            stroke="#E6E6E6"
            strokeWidth="2"
          />

          <text
            x="400"
            y="72"
            textAnchor="middle"
            fill="#555555"
            fontSize="18"
            fontWeight="700"
          >
            Total a pagar
          </text>

          <text
            x="400"
            y="116"
            textAnchor="middle"
            fill="#0F4C75"
            fontSize="36"
            fontWeight="900"
          >
            ${montoCuenta.toFixed(2)}
          </text>

          <rect
            x="83"
            y="133"
            width="282"
            height="78"
            rx="15"
            fill="#FFFFFF"
            stroke="#E6E6E6"
            strokeWidth="2"
          />

          <rect
            x="435"
            y="133"
            width="282"
            height="78"
            rx="15"
            fill="#FFFFFF"
            stroke="#0F4C75"
            strokeWidth="2"
          />

          <text
            x="224"
            y="160"
            textAnchor="middle"
            fill="#666666"
            fontSize="15"
            fontWeight="800"
          >
            Ingresado
          </text>

          <text
            x="224"
            y="193"
            textAnchor="middle"
            fill="#222222"
            fontSize="24"
            fontWeight="900"
          >
            ${montoIngresado.toFixed(2)}
          </text>

          <text
            x="576"
            y="160"
            textAnchor="middle"
            fill="#666666"
            fontSize="15"
            fontWeight="800"
          >
            {cambio > 0 ? "Cambio" : "Restante"}
          </text>

          <text
            x="576"
            y="193"
            textAnchor="middle"
            fill="#222222"
            fontSize="24"
            fontWeight="900"
          >
            ${(cambio > 0 ? cambio : restante).toFixed(2)}
          </text>

          <text
            x="400"
            y="257"
            textAnchor="middle"
            fill="#737373"
            fontSize="21"
            fontWeight="700"
            fontStyle="italic"
          >
            Ingresa monedas y/o billetes.
          </text>

          {/* Indicadores simples de efectivo */}
          <g transform="translate(263 280)">
            <circle
              cx="28"
              cy="28"
              r="25"
              fill="#F3F7FB"
              stroke="#D7E3F3"
              strokeWidth="2"
            />
            <text
              x="28"
              y="35"
              textAnchor="middle"
              fill="#0F4C75"
              fontSize="23"
              fontWeight="900"
            >
              $
            </text>

            <rect
              x="88"
              y="7"
              width="97"
              height="43"
              rx="7"
              fill="#E8F2DF"
              stroke="#7D9D79"
              strokeWidth="2"
            />
            <text
              x="136"
              y="34"
              textAnchor="middle"
              fill="#43624A"
              fontSize="18"
              fontWeight="900"
            >
              $
            </text>
          </g>

          {(estado === ESTADOS.PROCESANDO ||
            estado === ESTADOS.ENTREGANDO_CAMBIO) && (
              <>
                <rect
                  x="548"
                  y="286"
                  width="165"
                  height="50"
                  rx="14"
                  fill="#EEF4FA"
                />
                <text
                  x="630"
                  y="318"
                  textAnchor="middle"
                  fill="#0F4C75"
                  fontSize="16"
                  fontWeight="900"
                >
                  Procesando...
                </text>
              </>
            )}
        </>
      )}

      {/* =====================================================
          MENSAJE FINAL
          Basado visualmente en MensajeFinal.js
      ===================================================== */}
      {esFinal && (
        <>
          <rect x="0" y="0" width={W} height={H} fill="#FFFFFF" />

          <circle
            cx="112"
            cy="112"
            r="58"
            fill="#DCFCE7"
            stroke="#16A34A"
            strokeWidth="4"
          />

          <path
            d="M83 111 L103 132 L142 88"
            fill="none"
            stroke="#16A34A"
            strokeWidth="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          <text
            x="202"
            y="96"
            fill="#166534"
            fontSize="35"
            fontWeight="900"
          >
            Pago exitoso
          </text>

          <text
            x="202"
            y="132"
            fill="#374151"
            fontSize="18"
            fontWeight="700"
          >
            Transacción exitosa.
          </text>

          <rect
            x="202"
            y="157"
            width="260"
            height="75"
            rx="14"
            fill="#F9FAFB"
            stroke="#E5E7EB"
            strokeWidth="2"
          />

          <text
            x="332"
            y="182"
            textAnchor="middle"
            fill="#6B7280"
            fontSize="13"
            fontWeight="800"
          >
            Folio
          </text>

          <text
            x="332"
            y="213"
            textAnchor="middle"
            fill="#111827"
            fontSize="21"
            fontWeight="900"
          >
            {folio}
          </text>

          <rect
            x="484"
            y="157"
            width="260"
            height="75"
            rx="14"
            fill="#F9FAFB"
            stroke="#E5E7EB"
            strokeWidth="2"
          />

          <text
            x="614"
            y="182"
            textAnchor="middle"
            fill="#6B7280"
            fontSize="13"
            fontWeight="800"
          >
            Monto
          </text>

          <text
            x="614"
            y="213"
            textAnchor="middle"
            fill="#111827"
            fontSize="21"
            fontWeight="900"
          >
            ${montoCuenta.toFixed(2)}
          </text>

          <rect
            x="202"
            y="264"
            width="542"
            height="71"
            rx="16"
            fill="#16A34A"
          />

          <text
            x="473"
            y="308"
            textAnchor="middle"
            fill="#FFFFFF"
            fontSize="20"
            fontWeight="900"
          >
            Pago completado correctamente
          </text>
        </>
      )}
    </g>
  );
};

/*
 * ============================================================
 * PANTALLA APS101
 * ============================================================
 *
 * El APS101 tiene pantalla VERTICAL.
 *
 * No reutilizamos el lienzo horizontal 800 x 385 de SUNMI porque
 * al forzarlo dentro de una pantalla vertical se deformaban textos,
 * botones y QR. Este componente trabaja nativamente en 420 x 760,
 * prácticamente la misma proporción de la pantalla física del APS101.
 */
const Aps101Screen = ({
  estado,
  montoCuenta,
  montoIngresado,
  restante,
  cambio,
  folio,
}) => {
  const W = 420;
  const H = 760;

  const esPago =
    estado === ESTADOS.CUENTA_CARGADA ||
    estado === ESTADOS.RECIBIENDO ||
    estado === ESTADOS.PROCESANDO ||
    estado === ESTADOS.ENTREGANDO_CAMBIO;

  const esFinal =
    estado === ESTADOS.PAGADO;

  const esEscaneando =
    estado === ESTADOS.ESCANEANDO;

  return (
    <g>
      {/* Fondo de la aplicación ocupando TODO el LCD */}
      <rect
        x="0"
        y="0"
        width={W}
        height={H}
        fill="#FFFFFF"
      />

      {/* =====================================================
          ESPERA / ESCANEO
      ===================================================== */}
      {!esPago && !esFinal && (
        <>
          <rect
            x="18"
            y="18"
            width="384"
            height="724"
            rx="24"
            fill="#FFFFFF"
            stroke="#2F6ECF"
            strokeWidth="3"
          />

          <text
            x="210"
            y="82"
            textAnchor="middle"
            fill="#111827"
            fontSize="29"
            fontWeight="900"
          >
            {esEscaneando
              ? "Leyendo tu código..."
              : "Escanea tu código"}
          </text>

          <text
            x="210"
            y="118"
            textAnchor="middle"
            fill="#667085"
            fontSize="16"
            fontWeight="600"
          >
            Acerca el QR al lector
          </text>

          {/* QR grande y nítido */}
          <g transform="translate(95 175)">
            <rect
              x="0"
              y="0"
              width="230"
              height="230"
              rx="22"
              fill="#F4F7FB"
            />

            <g fill="#17375E">
              <rect x="24" y="24" width="62" height="62" rx="4" />
              <rect x="144" y="24" width="62" height="62" rx="4" />
              <rect x="24" y="144" width="62" height="62" rx="4" />

              <rect x="36" y="36" width="38" height="38" fill="#FFFFFF" />
              <rect x="156" y="36" width="38" height="38" fill="#FFFFFF" />
              <rect x="36" y="156" width="38" height="38" fill="#FFFFFF" />

              <rect x="128" y="116" width="22" height="22" />
              <rect x="160" y="112" width="46" height="20" />
              <rect x="116" y="150" width="26" height="56" />
              <rect x="154" y="154" width="20" height="20" />
              <rect x="184" y="146" width="22" height="60" />
              <rect x="150" y="184" width="22" height="22" />
            </g>

            {esEscaneando && (
              <rect
                x="12"
                y="16"
                width="206"
                height="6"
                rx="3"
                fill="#22C3FF"
              >
                <animate
                  attributeName="y"
                  values="16;208;16"
                  dur="1.05s"
                  repeatCount="indefinite"
                />
              </rect>
            )}
          </g>

          <rect
            x="62"
            y="470"
            width="296"
            height="76"
            rx="16"
            fill="#F5F8FC"
            stroke="#2F6ECF"
            strokeWidth="2"
          />

          <text
            x="210"
            y="516"
            textAnchor="middle"
            fill="#2F6ECF"
            fontSize="20"
            fontWeight="900"
          >
            {esEscaneando
              ? "Procesando..."
              : "Listo para escanear"}
          </text>

          <text
            x="210"
            y="620"
            textAnchor="middle"
            fill="#7B8798"
            fontSize="15"
            fontWeight="600"
          >
            Sigue las instrucciones
          </text>

          <text
            x="210"
            y="646"
            textAnchor="middle"
            fill="#7B8798"
            fontSize="15"
            fontWeight="600"
          >
            para realizar tu pago
          </text>
        </>
      )}

      {/* =====================================================
          PAGO
      ===================================================== */}
      {esPago && (
        <>
          <rect
            x="14"
            y="14"
            width="392"
            height="732"
            rx="22"
            fill="#FFFFFF"
          />

          <text
            x="210"
            y="58"
            textAnchor="middle"
            fill="#5F6B7A"
            fontSize="18"
            fontWeight="800"
          >
            Total a pagar
          </text>

          <text
            x="210"
            y="112"
            textAnchor="middle"
            fill="#0F4C75"
            fontSize="42"
            fontWeight="900"
          >
            ${montoCuenta.toFixed(2)}
          </text>

          <rect
            x="34"
            y="148"
            width="352"
            height="116"
            rx="18"
            fill="#F8FAFC"
            stroke="#E2E8F0"
            strokeWidth="2"
          />

          <text
            x="210"
            y="184"
            textAnchor="middle"
            fill="#7A8594"
            fontSize="15"
            fontWeight="800"
          >
            INGRESADO
          </text>

          <text
            x="210"
            y="232"
            textAnchor="middle"
            fill="#111827"
            fontSize="32"
            fontWeight="900"
          >
            ${montoIngresado.toFixed(2)}
          </text>

          <rect
            x="34"
            y="282"
            width="352"
            height="116"
            rx="18"
            fill="#FFFFFF"
            stroke="#2F6ECF"
            strokeWidth="3"
          />

          <text
            x="210"
            y="318"
            textAnchor="middle"
            fill="#7A8594"
            fontSize="15"
            fontWeight="800"
          >
            {cambio > 0
              ? "CAMBIO"
              : "RESTANTE"}
          </text>

          <text
            x="210"
            y="366"
            textAnchor="middle"
            fill="#0F4C75"
            fontSize="32"
            fontWeight="900"
          >
            ${(cambio > 0
              ? cambio
              : restante
            ).toFixed(2)}
          </text>

          <text
            x="210"
            y="458"
            textAnchor="middle"
            fill="#596579"
            fontSize="19"
            fontWeight="800"
          >
            Ingresa monedas
          </text>

          <text
            x="210"
            y="486"
            textAnchor="middle"
            fill="#596579"
            fontSize="19"
            fontWeight="800"
          >
            y/o billetes
          </text>

          {/* Indicadores visuales */}
          <g transform="translate(96 525)">
            <circle
              cx="48"
              cy="48"
              r="42"
              fill="#EEF4FA"
              stroke="#CFDCEB"
              strokeWidth="2"
            />
            <text
              x="48"
              y="59"
              textAnchor="middle"
              fill="#0F4C75"
              fontSize="34"
              fontWeight="900"
            >
              $
            </text>

            <rect
              x="130"
              y="12"
              width="116"
              height="72"
              rx="12"
              fill="#E8F2DF"
              stroke="#7D9D79"
              strokeWidth="2"
            />
            <text
              x="188"
              y="59"
              textAnchor="middle"
              fill="#43624A"
              fontSize="29"
              fontWeight="900"
            >
              $
            </text>
          </g>

          {(estado ===
            ESTADOS.PROCESANDO ||
            estado ===
            ESTADOS.ENTREGANDO_CAMBIO) && (
              <>
                <rect
                  x="70"
                  y="650"
                  width="280"
                  height="66"
                  rx="15"
                  fill="#EAF2FB"
                />
                <text
                  x="210"
                  y="691"
                  textAnchor="middle"
                  fill="#0F4C75"
                  fontSize="19"
                  fontWeight="900"
                >
                  Procesando pago...
                </text>
              </>
            )}
        </>
      )}

      {/* =====================================================
          PAGO EXITOSO
      ===================================================== */}
      {esFinal && (
        <>
          <rect
            x="0"
            y="0"
            width={W}
            height={H}
            fill="#FFFFFF"
          />

          <circle
            cx="210"
            cy="128"
            r="70"
            fill="#DCFCE7"
            stroke="#16A34A"
            strokeWidth="5"
          />

          <path
            d="M174 128 L200 154 L250 98"
            fill="none"
            stroke="#16A34A"
            strokeWidth="13"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          <text
            x="210"
            y="242"
            textAnchor="middle"
            fill="#166534"
            fontSize="34"
            fontWeight="900"
          >
            Pago exitoso
          </text>

          <text
            x="210"
            y="280"
            textAnchor="middle"
            fill="#4B5563"
            fontSize="17"
            fontWeight="700"
          >
            Transacción exitosa
          </text>

          <rect
            x="44"
            y="330"
            width="332"
            height="112"
            rx="18"
            fill="#F8FAFC"
            stroke="#E5E7EB"
            strokeWidth="2"
          />

          <text
            x="210"
            y="366"
            textAnchor="middle"
            fill="#6B7280"
            fontSize="14"
            fontWeight="800"
          >
            FOLIO
          </text>

          <text
            x="210"
            y="410"
            textAnchor="middle"
            fill="#111827"
            fontSize="25"
            fontWeight="900"
          >
            {folio}
          </text>

          <rect
            x="44"
            y="462"
            width="332"
            height="112"
            rx="18"
            fill="#F8FAFC"
            stroke="#E5E7EB"
            strokeWidth="2"
          />

          <text
            x="210"
            y="498"
            textAnchor="middle"
            fill="#6B7280"
            fontSize="14"
            fontWeight="800"
          >
            MONTO
          </text>

          <text
            x="210"
            y="542"
            textAnchor="middle"
            fill="#111827"
            fontSize="27"
            fontWeight="900"
          >
            ${montoCuenta.toFixed(2)}
          </text>

          <rect
            x="44"
            y="620"
            width="332"
            height="76"
            rx="16"
            fill="#16A34A"
          />

          <text
            x="210"
            y="667"
            textAnchor="middle"
            fill="#FFFFFF"
            fontSize="18"
            fontWeight="900"
          >
            Pago completado
          </text>
        </>
      )}
    </g>
  );
};

const EmbeddedCashierCore = ({ montoInicial = null, flujoInicial = "QR", disparadorExterno = 0, modeloInicial = "e100" }) => {
  const svgRef = useRef(null);
  const dragRef = useRef(null);
  const timersRef = useRef([]);
  const rafsRef = useRef([]);

  /*
   * Conservamos referencias fuertes a las imágenes ya decodificadas.
   * Esto evita que el navegador tenga que reconstruir/decodificar
   * nuevamente el bitmap al cambiar de modelo.
   */
  const imagenesPrecargadasRef = useRef([]);

  const [modeloActivo, setModeloActivo] =
    useState(MODELOS[modeloInicial] ? modeloInicial : "e100");

  /*
   * El acceso a calibración queda oculto por defecto.
   * El switch inferior izquierdo permite habilitarlo cuando
   * realmente se necesita ajustar posiciones.
   */
  const [mostrarBotonCalibracion, setMostrarBotonCalibracion] =
    useState(false);

  /*
   * Modal informativo para la futura función
   * "Prueba tu integración".
   */
  const [mostrarIntegracion, setMostrarIntegracion] =
    useState(false);

  /*
   * ============================================================
   * PRECARGA DE IMÁGENES
   * ============================================================
   *
   * Las imágenes se cargan y decodifican ANTES de mostrar
   * el simulador. Esto evita que, al cambiar rápidamente entre
   * pestañas, el <image> del SVG quede temporalmente sin recurso
   * decodificado y aparezca borroso o como imagen rota.
   */
  const [imagenesListas, setImagenesListas] =
    useState(false);

  const modelo = MODELOS[modeloActivo];

  const [estado, setEstado] =
    useState(ESTADOS.ESPERANDO);

  const [montoCuenta, setMontoCuenta] = useState(0);
  const [montoIngresado, setMontoIngresado] = useState(0);
  const [folio, setFolio] = useState("");

  const [mensaje, setMensaje] = useState(
    "Escanea tu código para comenzar la simulación."
  );

  const [billeteAnimacion, setBilleteAnimacion] =
    useState(null);

  const [billeteProgreso, setBilleteProgreso] =
    useState(0);

  const [monedaAnimacion, setMonedaAnimacion] =
    useState(null);

  const [monedaProgreso, setMonedaProgreso] =
    useState(0);

  const [ticketVisible, setTicketVisible] =
    useState(false);

  const [ticketProgreso, setTicketProgreso] =
    useState(0);

  const [cambioVisible, setCambioVisible] =
    useState(false);

  const [modoCalibracion, setModoCalibracion] =
    useState(false);

  const [elementoActivo, setElementoActivo] =
    useState("display");

  /*
   * Precarga real de todos los assets de los cajeros.
   *
   * - Espera el evento onload.
   * - Si el navegador soporta decode(), espera también la
   *   decodificación completa del PNG.
   * - Las imágenes importadas quedan en caché antes de permitir
   *   cambiar de modelo.
   */
  useEffect(() => {
    let activo = true;
    const linksPreload = [];

    const fuentes = [
      ...new Set(
        Object.values(MODELOS).map(
          (item) => item.image
        )
      ),
    ];

    /*
     * Pedimos al navegador todas las imágenes desde el primer momento.
     * En producción esto evita esperar a que el usuario haga clic
     * para iniciar una descarga.
     */
    fuentes.forEach((src) => {
      try {
        const link =
          document.createElement("link");

        link.rel = "preload";
        link.as = "image";
        link.href = src;

        document.head.appendChild(link);
        linksPreload.push(link);
      } catch (error) {
        // Si el navegador no permite insertar el preload,
        // la precarga con Image() sigue funcionando.
      }
    });

    const cargarImagen = (src) =>
      new Promise((resolve) => {
        const img = new Image();

        /*
         * Mantener esta referencia es importante:
         * el recurso queda vivo y decodificado mientras el
         * componente del simulador permanezca montado.
         */
        imagenesPrecargadasRef.current.push(
          img
        );

        try {
          img.fetchPriority = "high";
          img.decoding = "async";
        } catch (error) {
          // Propiedades opcionales según navegador.
        }

        const terminar = async () => {
          try {
            if (
              typeof img.decode === "function"
            ) {
              await img.decode();
            }
          } catch (error) {
            /*
             * onload ya garantiza que el archivo llegó.
             * Algunos navegadores pueden rechazar decode()
             * aunque la imagen sea completamente utilizable.
             */
          }

          resolve();
        };

        img.onload = terminar;

        img.onerror = () => {
          console.error(
            "No se pudo precargar imagen del simulador:",
            src
          );

          resolve();
        };

        img.src = src;

        if (
          img.complete &&
          img.naturalWidth > 0
        ) {
          terminar();
        }
      });

    const precargarImagenes =
      async () => {
        await Promise.all(
          fuentes.map(cargarImagen)
        );

        if (activo) {
          setImagenesListas(true);
        }
      };

    precargarImagenes();

    return () => {
      activo = false;

      linksPreload.forEach((link) => {
        try {
          link.remove();
        } catch (error) {
          // Sin acción.
        }
      });

      imagenesPrecargadasRef.current = [];
    };
  }, []);

  /*
   * ============================================================
   * CALIBRACIONES POR MODELO
   * ============================================================
   */
  const [calibraciones, setCalibraciones] = useState(() => {
    const result = {};

    Object.values(MODELOS).forEach((item) => {
      try {
        const guardado =
          localStorage.getItem(item.storageKey);

        result[item.key] = guardado
          ? {
            ...item.zonas,
            ...JSON.parse(guardado),
          }
          : item.zonas;
      } catch (error) {
        result[item.key] = item.zonas;
      }
    });

    return result;
  });

  const zonas = calibraciones[modeloActivo];

  const restante = useMemo(() => {
    return Math.max(montoCuenta - montoIngresado, 0);
  }, [montoCuenta, montoIngresado]);

  const cambio = useMemo(() => {
    return Math.max(montoIngresado - montoCuenta, 0);
  }, [montoCuenta, montoIngresado]);

  const pagoActivo =
    estado === ESTADOS.CUENTA_CARGADA ||
    estado === ESTADOS.RECIBIENDO;

  const dineroEnMovimiento =
    billeteAnimacion !== null ||
    monedaAnimacion !== null;

  /*
   * ============================================================
   * TIMERS / RAF
   * ============================================================
   */
  const limpiarTimers = () => {
    timersRef.current.forEach((id) =>
      clearTimeout(id)
    );

    timersRef.current = [];
  };

  const limpiarRafs = () => {
    rafsRef.current.forEach((id) =>
      cancelAnimationFrame(id)
    );

    rafsRef.current = [];
  };

  const despues = (callback, ms) => {
    const id = setTimeout(() => {
      timersRef.current =
        timersRef.current.filter(
          (item) => item !== id
        );

      callback();
    }, ms);

    timersRef.current.push(id);
  };

  const animarProgreso = (
    setter,
    duracion,
    callback
  ) => {
    const inicio = performance.now();

    const frame = (now) => {
      const raw = Math.min(
        (now - inicio) / duracion,
        1
      );

      const p =
        raw < 0.5
          ? 4 * raw * raw * raw
          : 1 -
          Math.pow(-2 * raw + 2, 3) / 2;

      setter(p);

      if (raw < 1) {
        const id =
          requestAnimationFrame(frame);

        rafsRef.current.push(id);
      } else if (callback) {
        callback();
      }
    };

    setter(0);

    const id =
      requestAnimationFrame(frame);

    rafsRef.current.push(id);
  };

  useEffect(() => {
    return () => {
      limpiarTimers();
      limpiarRafs();
    };
  }, []);

  /*
   * ============================================================
   * FLUJO
   * ============================================================
   */
  const limpiarOperacion = () => {
    limpiarTimers();
    limpiarRafs();

    setMontoCuenta(0);
    setMontoIngresado(0);
    setFolio("");

    setBilleteAnimacion(null);
    setBilleteProgreso(0);

    setMonedaAnimacion(null);
    setMonedaProgreso(0);

    setTicketVisible(false);
    setTicketProgreso(0);

    setCambioVisible(false);
  };

  const reiniciar = () => {
    limpiarOperacion();

    setEstado(ESTADOS.ESPERANDO);

    setMensaje(
      "Escanea tu código para comenzar la simulación."
    );
  };

  const cambiarModelo = (key) => {
    if (
      key === modeloActivo ||
      !imagenesListas
    ) {
      return;
    }

    /*
     * Primero limpiamos la operación del modelo actual.
     * Las imágenes de todos los modelos ya permanecen cargadas
     * y montadas en el SVG, por lo que aquí sólo cambia el modelo
     * visible y sus overlays. El cambio debe sentirse inmediato.
     */
    limpiarOperacion();

    setModoCalibracion(false);
    setElementoActivo("display");

    setEstado(ESTADOS.ESPERANDO);

    setMensaje(
      "Escanea tu código para comenzar la simulación."
    );

    setModeloActivo(key);
  };

  const escanearQR = (montoForzado = null) => {
    if (
      estado === ESTADOS.ESCANEANDO ||
      estado === ESTADOS.PROCESANDO ||
      estado ===
      ESTADOS.ENTREGANDO_CAMBIO
    ) {
      return;
    }

    limpiarOperacion();

    setEstado(ESTADOS.ESCANEANDO);

    setMensaje("Leyendo código QR...");

    despues(() => {
      const recibido = Number(montoForzado);
      const total =
        Number.isFinite(recibido) && recibido > 0
          ? recibido
          : generarMontoDemo();

      setMontoCuenta(total);
      setMontoIngresado(0);

      setFolio(generarFolioDemo());

      setEstado(
        ESTADOS.CUENTA_CARGADA
      );

      setMensaje(
        `Pago cargado correctamente. Total a pagar: $${total.toFixed(
          2
        )}`
      );
    }, 1200);
  };

  const recibirMontoExternoDirecto = (montoForzado) => {
    const total = Number(montoForzado);
    if (!Number.isFinite(total) || total <= 0) return;

    limpiarOperacion();
    setMontoCuenta(total);
    setMontoIngresado(0);
    setFolio(generarFolioDemo());
    setEstado(ESTADOS.CUENTA_CARGADA);
    setMensaje(`Pago recibido desde Empática POS. Total a pagar: $${total.toFixed(2)}`);
  };

  useEffect(() => {
    if (!disparadorExterno) return;

    const total = Number(montoInicial);
    if (!Number.isFinite(total) || total <= 0) return;

    if (flujoInicial === "DIRECTO") {
      recibirMontoExternoDirecto(total);
    } else {
      escanearQR(total);
    }
    // Cada incremento representa una nueva orden enviada por EcosistemaPos.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disparadorExterno]);

  const registrarDinero = (cantidad) => {
    const nuevo = Number(
      (
        montoIngresado + cantidad
      ).toFixed(2)
    );

    setMontoIngresado(nuevo);

    if (nuevo < montoCuenta) {
      setEstado(ESTADOS.RECIBIENDO);

      setMensaje(
        `Ingresado: $${nuevo.toFixed(
          2
        )}. Faltan $${(
          montoCuenta - nuevo
        ).toFixed(2)}.`
      );

      return;
    }

    setEstado(ESTADOS.PROCESANDO);

    setMensaje(
      `Ingresado: $${nuevo.toFixed(
        2
      )}. Procesando pago...`
    );

    despues(() => {
      finalizarPago(nuevo);
    }, 900);
  };

  const ingresarBillete = (cantidad) => {
    if (
      !pagoActivo ||
      dineroEnMovimiento ||
      modoCalibracion
    ) {
      return;
    }

    limpiarRafs();

    setBilleteAnimacion(cantidad);
    setBilleteProgreso(0);

    setMensaje(
      `Ingresando billete de $${cantidad}...`
    );

    animarProgreso(
      setBilleteProgreso,
      950,
      () => {
        setBilleteAnimacion(null);
        setBilleteProgreso(0);

        registrarDinero(cantidad);
      }
    );
  };

  const ingresarMoneda = (cantidad) => {
    if (
      !pagoActivo ||
      dineroEnMovimiento ||
      modoCalibracion
    ) {
      return;
    }

    limpiarRafs();

    setMonedaAnimacion(cantidad);
    setMonedaProgreso(0);

    setMensaje(
      `Ingresando moneda de $${cantidad}...`
    );

    animarProgreso(
      setMonedaProgreso,
      800,
      () => {
        setMonedaAnimacion(null);
        setMonedaProgreso(0);

        registrarDinero(cantidad);
      }
    );
  };

  const finalizarPago = (montoFinal) => {
    const cambioFinal =
      Math.max(
        montoFinal - montoCuenta,
        0
      );

    if (cambioFinal > 0) {
      setEstado(
        ESTADOS.ENTREGANDO_CAMBIO
      );

      setCambioVisible(true);

      setMensaje(
        `Pago aprobado. Entregando cambio de $${cambioFinal.toFixed(
          2
        )}.`
      );

      despues(() => {
        setCambioVisible(false);
        completarPago();
      }, 1350);

      return;
    }

    completarPago();
  };

  const completarPago = () => {
    setEstado(ESTADOS.PAGADO);

    setMensaje(
      "Pago realizado correctamente."
    );

    setTicketVisible(true);
    setTicketProgreso(0);

    animarProgreso(
      setTicketProgreso,
      1500
    );

    /*
     * Después de mostrar el resultado final durante 7 segundos,
     * el simulador vuelve automáticamente al estado normal,
     * sin ningún proceso activo.
     */
    despues(() => {
      reiniciar();
    }, 7000);
  };

  const cancelarOperacion = () => {
    if (modoCalibracion) {
      return;
    }

    limpiarOperacion();

    setEstado(
      ESTADOS.CANCELADO
    );

    setMensaje(
      "Operación cancelada."
    );

    /*
     * La cancelación sólo se muestra brevemente.
     * El timer de 7 segundos se conserva únicamente
     * para el estado de pago exitoso.
     */
    despues(() => {
      reiniciar();
    }, 2000);
  };

  /*
   * ============================================================
   * CALIBRACIÓN
   * ============================================================
   */
  const clavesCalibracion =
    useMemo(() => {
      if (
        modeloActivo ===
        "quickpayMini"
      ) {
        return [
          {
            key: "display",
            label: "Display",
          },
          {
            key: "scanner",
            label: "Scanner QR",
          },
          {
            key: "billetero",
            label: "Billetero",
          },
          {
            key: "monedero",
            label: "Entrada monedas",
          },
          {
            key: "ticket",
            label: "Ticket",
          },
          {
            key: "cambioMonedas",
            label: "Cambio monedas",
          },
        ];
      }

      if (
        modeloActivo ===
        "e100"
      ) {
        return [
          {
            key: "display",
            label: "Pantalla SUNMI",
          },
          {
            key: "scanner",
            label: "Scanner SUNMI",
          },
          {
            key: "sunmiTicket",
            label: "Ticket SUNMI",
          },
          {
            key: "billetero",
            label: "Billetes / cambio billetes",
          },
          {
            key: "monedero",
            label: "Entrada monedas",
          },
          {
            key: "cambioMonedas",
            label: "Cambio monedas",
          },
        ];
      }

      if (
        modeloActivo ===
        "e300"
      ) {
        return [
          {
            key: "display",
            label: "Pantalla SUNMI",
          },
          {
            key: "scanner",
            label: "Scanner SUNMI",
          },
          {
            key: "sunmiTicket",
            label: "Ticket SUNMI",
          },
          {
            key: "billetero",
            label: "Billetes / cambio billetes",
          },
          {
            key: "cambioBilletes",
            label: "Salida cambio billetes",
          },
          {
            key: "monedero",
            label: "Entrada monedas",
          },
          {
            key: "cambioMonedas",
            label: "Cambio monedas",
          },
        ];
      }

      if (
        modeloActivo ===
        "aps101"
      ) {
        return [
          {
            key: "display",
            label: "Pantalla",
          },
          {
            key: "scanner",
            label: "Scanner QR",
          },
          {
            key: "billetero",
            label: "Billetero",
          },
          {
            key: "ticket",
            label: "Ticket",
          },
          {
            key: "monedero",
            label: "Entrada monedas",
          },
          {
            key: "cambioMonedas",
            label: "Bandeja cambio",
          },
        ];
      }

      if (
        modeloActivo ===
        "aps301"
      ) {
        return [
          {
            key: "display",
            label: "Pantalla",
          },
          {
            key: "scanner",
            label: "Scanner QR",
          },
          {
            key: "billetero",
            label: "Billetes / cambio billetes",
          },
          {
            key: "ticket",
            label: "Ticket",
          },
          {
            key: "monedero",
            label: "Entrada monedas",
          },
          {
            key: "cambioMonedas",
            label: "Bandeja cambio",
          },
        ];
      }

      return [
        {
          key: "display",
          label: "Pantalla SUNMI",
        },
        {
          key: "scanner",
          label: "Scanner SUNMI",
        },
        {
          key: "sunmiTicket",
          label: "Ticket SUNMI",
        },
        {
          key: "billetero",
          label: "Entrada billetes",
        },
        {
          key: "cambioBilletes",
          label: "Cambio billetes",
        },
        {
          key: "monedero",
          label: "Entrada monedas",
        },
        {
          key: "cambioMonedas",
          label: "Cambio monedas",
        },
      ];
    }, [modeloActivo]);

  const clienteASvg = (
    clientX,
    clientY
  ) => {
    const svg = svgRef.current;

    if (!svg) {
      return {
        x: 0,
        y: 0,
      };
    }

    const rect =
      svg.getBoundingClientRect();

    return {
      x:
        ((clientX - rect.left) /
          rect.width) *
        modelo.viewW,

      y:
        ((clientY - rect.top) /
          rect.height) *
        modelo.viewH,
    };
  };

  const iniciarDrag = (
    e,
    key,
    tipo = "mover"
  ) => {
    if (!modoCalibracion) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const point = clienteASvg(
      e.clientX,
      e.clientY
    );

    const actual = zonas[key];

    dragRef.current = {
      key,
      tipo,
      startX: point.x,
      startY: point.y,
      original: {
        ...actual,
      },
    };

    setElementoActivo(key);
  };

  const moverDrag = (e) => {
    const drag =
      dragRef.current;

    if (
      !drag ||
      !modoCalibracion
    ) {
      return;
    }

    const point = clienteASvg(
      e.clientX,
      e.clientY
    );

    const dx =
      point.x - drag.startX;

    const dy =
      point.y - drag.startY;

    setCalibraciones((prev) => {
      const currentModel = {
        ...prev[modeloActivo],
      };

      const original =
        drag.original;

      if (drag.tipo === "mover") {
        currentModel[drag.key] = {
          ...original,

          x: clamp(
            original.x + dx,
            0,
            modelo.viewW -
            original.width
          ),

          y: clamp(
            original.y + dy,
            0,
            modelo.viewH -
            original.height
          ),
        };
      } else {
        currentModel[drag.key] = {
          ...original,

          width: clamp(
            original.width + dx,
            10,
            modelo.viewW -
            original.x
          ),

          height: clamp(
            original.height + dy,
            10,
            modelo.viewH -
            original.y
          ),
        };
      }

      return {
        ...prev,
        [modeloActivo]:
          currentModel,
      };
    });
  };

  const terminarDrag = () => {
    dragRef.current = null;
  };

  useEffect(() => {
    window.addEventListener(
      "mousemove",
      moverDrag
    );

    window.addEventListener(
      "mouseup",
      terminarDrag
    );

    return () => {
      window.removeEventListener(
        "mousemove",
        moverDrag
      );

      window.removeEventListener(
        "mouseup",
        terminarDrag
      );
    };
  });

  const actualizarCampo = (
    key,
    field,
    value
  ) => {
    const numero =
      Number(value);

    if (
      Number.isNaN(numero)
    ) {
      return;
    }

    setCalibraciones((prev) => ({
      ...prev,

      [modeloActivo]: {
        ...prev[modeloActivo],

        [key]: {
          ...prev[modeloActivo][
          key
          ],

          [field]: numero,
        },
      },
    }));
  };

  const guardarCalibracion = () => {
    localStorage.setItem(
      modelo.storageKey,
      JSON.stringify(zonas)
    );

    setMensaje(
      `Calibración de ${modelo.label} guardada.`
    );
  };

  const restaurarCalibracion =
    () => {
      setCalibraciones(
        (prev) => ({
          ...prev,
          [modeloActivo]:
            modelo.zonas,
        })
      );

      localStorage.removeItem(
        modelo.storageKey
      );
    };

  const calibracionJson =
    useMemo(() => {
      return JSON.stringify(
        zonas,
        null,
        2
      );
    }, [zonas]);

  const copiarCalibracion =
    async () => {
      try {
        await navigator.clipboard.writeText(
          calibracionJson
        );

        setMensaje(
          "Calibración copiada."
        );
      } catch (error) {
        setMensaje(
          "No se pudo copiar automáticamente."
        );
      }
    };

  const actual =
    zonas[elementoActivo] || {
      x: 0,
      y: 0,
      width: 10,
      height: 10,
    };

  /*
   * ============================================================
   * GEOMETRÍA DE ANIMACIONES
   * ============================================================
   */
  const billeteVisual =
    useMemo(() => {
      const z =
        zonas.billetero;

      if (!z) {
        return null;
      }

      const width =
        Math.max(
          z.width - 24,
          70
        );

      const height =
        modeloActivo !== "quickpayMini"
          ? 42
          : 52;

      const x =
        z.x +
        z.width / 2 -
        width / 2;

      /*
       * Empieza cerca del billetero,
       * no desde muy arriba.
       */
      const startY =
        z.y -
        (modeloActivo !== "quickpayMini"
          ? 68
          : 105);

      const endY =
        z.y +
        z.height / 2 -
        height / 2 +
        3;

      const y =
        startY +
        (endY - startY) *
        billeteProgreso;

      const finalPhase =
        Math.max(
          (billeteProgreso -
            0.78) /
          0.22,
          0
        );

      const scaleY =
        1 -
        0.8 * finalPhase;

      const opacity =
        billeteProgreso < 0.92
          ? 1
          : Math.max(
            1 -
            (billeteProgreso -
              0.92) /
            0.08,
            0
          );

      return {
        x,
        y,
        width,
        height,
        scaleY,
        opacity,
      };
    }, [
      zonas,
      billeteProgreso,
      modeloActivo,
    ]);

  const monedaVisual =
    useMemo(() => {
      const z =
        zonas.monedero;

      if (!z) {
        return null;
      }

      const cx =
        z.x + z.width / 2;

      const endCy =
        z.y + z.height / 2;

      const startCy =
        z.y -
        (modeloActivo !== "quickpayMini"
          ? 45
          : 70);

      const cy =
        startCy +
        (endCy - startCy) *
        monedaProgreso;

      const r =
        modeloActivo !== "quickpayMini"
          ? 18
          : 22;

      const finalPhase =
        Math.max(
          (monedaProgreso -
            0.78) /
          0.22,
          0
        );

      const scaleY =
        1 -
        0.8 * finalPhase;

      const opacity =
        monedaProgreso < 0.9
          ? 1
          : Math.max(
            1 -
            (monedaProgreso -
              0.9) /
            0.1,
            0
          );

      return {
        cx,
        cy,
        r,
        scaleY,
        opacity,
      };
    }, [
      zonas,
      monedaProgreso,
      modeloActivo,
    ]);

  const zonaTicket =
    modeloActivo === "e200" ||
      modeloActivo === "e100" ||
      modeloActivo === "e300"
      ? zonas.sunmiTicket
      : zonas.ticket;

  const ticketData =
    useMemo(() => {
      if (!zonaTicket) {
        return null;
      }

      const paperHeight =
        modeloActivo !== "quickpayMini"
          ? 135
          : 172;

      const slotBottom =
        zonaTicket.y +
        zonaTicket.height;

      const salida =
        modeloActivo !== "quickpayMini"
          ? 105
          : 118;

      const paperY =
        slotBottom -
        paperHeight +
        ticketProgreso *
        salida;

      return {
        ...zonaTicket,
        paperHeight,
        slotBottom,
        paperY,
      };
    }, [
      zonaTicket,
      ticketProgreso,
      modeloActivo,
    ]);

  const montoDisplay =
    estado ===
      ESTADOS.CUENTA_CARGADA
      ? montoCuenta.toFixed(2)
      : [
        ESTADOS.RECIBIENDO,
        ESTADOS.PROCESANDO,
        ESTADOS.ENTREGANDO_CAMBIO,
        ESTADOS.PAGADO,
      ].includes(estado)
        ? montoIngresado.toFixed(2)
        : "0.00";

  /*
   * ============================================================
   * RENDER
   * ============================================================
   */

  /*
   * No mostramos las pestañas hasta que QuickPay Mini,
   * E200 y E100 ya estén cargados y decodificados.
   * De esta forma el usuario no puede provocar una carrera de
   * cargas cambiando rápidamente entre modelos.
   */
  if (!imagenesListas) {
    return (
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#FFFFFF",
          color: "#475569",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        }}
      >
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: 800,
              color: "#111827",
            }}
          >
            Cargando simulador...
          </div>

          <div
            style={{
              marginTop: 6,
              fontSize: 12,
            }}
          >
            Preparando los modelos del simulador
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }

        html,
        body {
          margin: 0;
        }

        .sim-page {
          width: 100%;
          height: 100vh;
          min-height: 100vh;
          overflow: hidden;
          background:
            linear-gradient(180deg, #EEF5FF 0%, #F8FBFF 26%, #FFFFFF 58%);
          color: #162033;
          font-family:
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            Roboto,
            Helvetica,
            Arial,
            sans-serif;
        }

        .sim-wrap {
          width: 100%;
          max-width: 1380px;
          height: 100vh;
          margin: 0 auto;
          padding: 10px 18px 12px;
          display: grid;
          grid-template-rows: auto auto minmax(0, 1fr);
          gap: 8px;
        }

        /* =====================================================
           CABECERA EMPÁTICA - compacta para no desplazar simulador
        ===================================================== */
        .sim-top {
          min-height: 68px;
          display: grid;
          grid-template-columns: 170px minmax(0, 1fr);
          align-items: center;
          gap: 18px;
          padding: 9px 16px;
          border-radius: 18px;
          background:
            linear-gradient(120deg, #1F5FAF 0%, #2F73C9 55%, #3E83D6 100%);
          box-shadow: 0 10px 26px rgba(31, 95, 175, 0.22);
          position: relative;
          overflow: hidden;
        }

        .sim-top::after {
          content: "";
          position: absolute;
          width: 260px;
          height: 260px;
          right: -80px;
          top: -140px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.10);
          pointer-events: none;
        }

        .sim-brand-card {
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 5px 12px;
          border-radius: 12px;
          background: #FFFFFF;
          box-shadow: 0 5px 14px rgba(8, 47, 93, 0.18);
          z-index: 1;
        }

        .sim-brand-card img {
          width: 100%;
          max-width: 145px;
          max-height: 42px;
          height: auto;
          object-fit: contain;
          display: block;
        }

        .sim-title {
          min-width: 0;
          z-index: 1;
        }

        .sim-kicker {
          display: none;
        }

        .sim-title h1 {
          margin: 0;
          color: #FFFFFF;
          font-size: clamp(22px, 2.2vw, 31px);
          line-height: 1.05;
          font-weight: 850;
          letter-spacing: -0.02em;
        }

        .sim-title p {
          margin: 4px 0 0;
          color: rgba(255, 255, 255, 0.88);
          font-size: 12px;
          line-height: 1.35;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .sim-meta {
          display: none;
        }

        /* =====================================================
           SELECTOR DE MODELOS
        ===================================================== */
        .sim-tabs-shell {
          padding: 6px 10px;
          border: 1px solid #DDE8F4;
          border-radius: 14px;
          background: rgba(255, 255, 255, 0.96);
          box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
        }

        .sim-tabs {
          display: flex;
          gap: 7px;
          flex-wrap: nowrap;
        }

        .sim-tabs-over-device {
          width: 100%;
          margin: 0;
          justify-content: center;
          transform: none;
        }

        .sim-tab {
          min-width: 118px;
          padding: 8px 14px;
          border: 1px solid #CBD9EA;
          border-radius: 999px;
          background: #FFFFFF;
          color: #29435F;
          font-size: 11px;
          font-weight: 900;
          cursor: pointer;
          transition: all .18s ease;
        }

        .sim-tab:hover:not(:disabled) {
          border-color: #6EA1DE;
          color: #1F5FAF;
          background: #F5F9FF;
        }

        .sim-tab.active {
          border-color: #286CC0;
          background: linear-gradient(180deg, #367DD1 0%, #2566B5 100%);
          color: #FFFFFF;
          box-shadow: 0 6px 14px rgba(37, 102, 181, 0.22);
        }

        .sim-tab:disabled {
          cursor: wait;
          opacity: .65;
        }

        /* =====================================================
           ÁREA PRINCIPAL - SIEMPRE VISIBLE SIN SCROLL DE PÁGINA
        ===================================================== */
        .sim-layout {
          min-height: 0;
          height: 100%;
          display: grid;
          grid-template-columns:
            minmax(360px, 610px)
            minmax(350px, 460px);
          justify-content: center;
          align-items: stretch;
          gap: 24px;
          margin-top: 0;
        }

        .sim-device-area {
          min-height: 0;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          padding: 8px 12px;
          border: 1px solid #DCE8F4;
          border-radius: 18px;
          background:
            radial-gradient(circle at 50% 10%, rgba(59, 130, 246, .10), transparent 32%),
            linear-gradient(180deg, #FFFFFF 0%, #F8FBFF 100%);
          box-shadow: 0 10px 26px rgba(15, 23, 42, .05);
        }

        .sim-machine {
          display: block;
          width: auto;
          height: 100%;
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          user-select: none;
          overflow: visible;
        }

        .sim-panel {
          min-height: 0;
          height: 100%;
          max-height: none;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          padding: 15px;
          border: 1px solid #DCE8F4;
          border-top: 4px solid #2F73C9;
          border-radius: 18px;
          background: #FFFFFF;
          box-shadow: 0 10px 26px rgba(15, 23, 42, .055);
          scrollbar-width: thin;
          scrollbar-color: #B7CBE4 transparent;
        }

        .sim-panel-head {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 10px;
          margin-bottom: 9px;
        }

        .sim-panel-kicker {
          color: #2F73C9;
          font-size: 9px;
          font-weight: 900;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }

        .sim-panel-title {
          margin-top: 2px;
          color: #0F172A;
          font-size: 18px;
          font-weight: 900;
          line-height: 1.08;
        }

        .sim-panel-subtitle {
          margin-top: 3px;
          color: #6B7B91;
          font-size: 10px;
          line-height: 1.3;
        }

        .sim-panel-model {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 76px;
          padding: 7px 10px;
          border-radius: 999px;
          background: #EAF3FF;
          color: #1F5FAF;
          border: 1px solid #CFE2F8;
          font-size: 10px;
          font-weight: 900;
        }

        .sim-status {
          display: inline-flex;
          align-items: center;
          padding: 7px 10px;
          border-radius: 999px;
          background: #EDF4FF;
          color: #1D5FC8;
          font-size: 10px;
          font-weight: 900;
        }

        .sim-message {
          margin-top: 8px;
          padding: 9px 11px;
          border-radius: 10px;
          background: #F8FAFC;
          color: #475569;
          font-size: 12px;
          line-height: 1.4;
        }

        .sim-summary {
          display: grid;
          grid-template-columns:
            repeat(3, 1fr);
          gap: 7px;
          margin-top: 8px;
        }

        .sim-summary-card {
          padding: 7px 5px;
          border: 1px solid #E4EAF2;
          border-radius: 10px;
          background: #FFFFFF;
          text-align: center;
        }

        .sim-summary-card span {
          display: block;
          color: #97A6BA;
          font-size: 8px;
          font-weight: 900;
        }

        .sim-summary-card strong {
          display: block;
          margin-top: 3px;
          color: #0F172A;
          font-size: 13px;
        }

        .sim-primary {
          width: 100%;
          margin-top: 9px;
          padding: 9px 11px;
          border: 0;
          border-radius: 10px;
          background: #2367D9;
          color: #FFFFFF;
          font-size: 12px;
          font-weight: 900;
          cursor: pointer;
        }

        .sim-secondary-return {
          background: #F8FAFC;
          color: #1F4F8C;
          border: 1px solid #D6E3F2;
        }

        .sim-section {
          margin-top: 10px;
        }

        .sim-section-title {
          margin: 0 0 3px;
          color: #1F2937;
          font-size: 12px;
          font-weight: 900;
        }

        .sim-section-help {
          margin: 0 0 8px;
          color: #7B8BA0;
          font-size: 9px;
          line-height: 1.35;
        }

        .sim-bills {
          display: grid;
          grid-template-columns:
            repeat(3, 1fr);
          gap: 7px;
        }

        .sim-money {
          min-height: 42px;
          border: 1px solid #DBE4EF;
          border-radius: 9px;
          background: #FFFFFF;
          color: #122338;
          font-size: 12px;
          font-weight: 900;
          cursor: pointer;
        }

        .sim-coins {
          display: grid;
          grid-template-columns:
            repeat(4, 1fr);
          gap: 8px;
        }

        .sim-coin {
          width: 47px;
          max-width: 100%;
          aspect-ratio: 1 / 1;
          justify-self: center;
          border: 1px solid #DBE4EF;
          border-radius: 50%;
          background: #FFFFFF;
          color: #122338;
          font-size: 11px;
          font-weight: 900;
          cursor: pointer;
        }

        .sim-cancel {
          width: 100%;
          margin-top: 13px;
          padding: 10px;
          border: 1px solid #FECACA;
          border-radius: 9px;
          background: #FFFFFF;
          color: #DC2626;
          font-size: 11px;
          font-weight: 900;
          cursor: pointer;
        }

        .sim-cal-toggle {
          width: 100%;
          margin-top: 10px;
          padding: 9px;
          border: 1px solid #D7E3F3;
          border-radius: 9px;
          background: #FFFFFF;
          color: #29435F;
          font-size: 10px;
          font-weight: 800;
          cursor: pointer;
        }

        /* =====================================================
           ACCESO A PRUEBA DE INTEGRACIÓN
        ===================================================== */
        .sim-integration-row {
          display: flex;
          justify-content: flex-end;
          margin-top: auto;
          padding-top: 14px;
          border-top: 1px solid #EDF2F7;
        }

        .sim-integration-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          padding: 9px 13px;
          border: 1px solid #BFD5F2;
          border-radius: 10px;
          background:
            linear-gradient(
              180deg,
              #F6FAFF 0%,
              #EAF3FF 100%
            );
          color: #1F5FAF;
          font-size: 10px;
          font-weight: 900;
          cursor: pointer;
          transition:
            transform .18s ease,
            box-shadow .18s ease,
            border-color .18s ease;
        }

        .sim-integration-btn:hover {
          transform: translateY(-1px);
          border-color: #8EB8EA;
          box-shadow:
            0 7px 18px
            rgba(47, 115, 201, .14);
        }

        .sim-integration-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #2F73C9;
          box-shadow:
            0 0 0 4px
            rgba(47, 115, 201, .10);
        }

        /* =====================================================
           MODAL "PRUEBA TU INTEGRACIÓN"
        ===================================================== */
        .sim-integration-overlay {
          position: fixed;
          inset: 0;
          z-index: 200;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          background:
            rgba(15, 23, 42, .48);
          backdrop-filter: blur(6px);
        }

        .sim-integration-modal {
          position: relative;
          width: min(100%, 470px);
          overflow: hidden;
          border: 1px solid
            rgba(255, 255, 255, .38);
          border-radius: 24px;
          background: #FFFFFF;
          box-shadow:
            0 28px 80px
            rgba(15, 23, 42, .28);
        }

        .sim-integration-modal-top {
          position: relative;
          min-height: 150px;
          padding: 28px 28px 24px;
          overflow: hidden;
          background:
            radial-gradient(
              circle at 88% 14%,
              rgba(255, 255, 255, .24),
              transparent 25%
            ),
            linear-gradient(
              135deg,
              #235FAF 0%,
              #377FCF 58%,
              #5A98DD 100%
            );
          color: #FFFFFF;
        }

        .sim-integration-modal-top::after {
          content: "";
          position: absolute;
          right: -50px;
          bottom: -75px;
          width: 190px;
          height: 190px;
          border: 26px solid
            rgba(255, 255, 255, .08);
          border-radius: 50%;
        }

        .sim-integration-badge {
          position: relative;
          z-index: 1;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          padding: 6px 10px;
          border: 1px solid
            rgba(255, 255, 255, .24);
          border-radius: 999px;
          background:
            rgba(255, 255, 255, .12);
          font-size: 9px;
          font-weight: 900;
          letter-spacing: .08em;
          text-transform: uppercase;
        }

        .sim-integration-title {
          position: relative;
          z-index: 1;
          margin-top: 15px;
          font-size: 26px;
          font-weight: 900;
          line-height: 1.08;
        }

        .sim-integration-body {
          padding: 24px 28px 27px;
        }

        .sim-integration-body p {
          margin: 0;
          color: #5E6D82;
          font-size: 13px;
          line-height: 1.55;
        }

        .sim-integration-coming {
          display: grid;
          grid-template-columns:
            42px 1fr;
          gap: 12px;
          align-items: center;
          margin-top: 18px;
          padding: 14px;
          border: 1px solid #DCE8F5;
          border-radius: 14px;
          background: #F7FAFE;
        }

        .sim-integration-coming-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          border-radius: 12px;
          background: #E8F2FF;
          color: #2868B7;
          font-size: 20px;
          font-weight: 900;
        }

        .sim-integration-coming strong {
          display: block;
          color: #173B65;
          font-size: 12px;
        }

        .sim-integration-coming span {
          display: block;
          margin-top: 3px;
          color: #718096;
          font-size: 10px;
          line-height: 1.4;
        }

        .sim-integration-close {
          width: 100%;
          margin-top: 18px;
          padding: 11px 14px;
          border: 0;
          border-radius: 11px;
          background: #2F73C9;
          color: #FFFFFF;
          font-size: 11px;
          font-weight: 900;
          cursor: pointer;
        }

        .sim-integration-x {
          position: absolute;
          top: 14px;
          right: 14px;
          z-index: 5;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          border: 1px solid
            rgba(255, 255, 255, .22);
          border-radius: 50%;
          background:
            rgba(255, 255, 255, .12);
          color: #FFFFFF;
          font-size: 16px;
          cursor: pointer;
        }

        /* =====================================================
           SWITCH DISCRETO DE CALIBRACIÓN
           Fijo abajo a la izquierda y apagado por defecto.
        ===================================================== */
        .sim-cal-access {
          position: fixed;
          left: 14px;
          bottom: 12px;
          z-index: 50;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 7px 9px;
          border: 1px solid rgba(47, 115, 201, .18);
          border-radius: 999px;
          background: rgba(255, 255, 255, .92);
          box-shadow: 0 8px 22px rgba(15, 23, 42, .08);
          backdrop-filter: blur(8px);
          user-select: none;
        }

        .sim-cal-access-label {
          color: #667085;
          font-size: 9px;
          font-weight: 800;
          white-space: nowrap;
        }

        .sim-switch {
          position: relative;
          display: inline-flex;
          width: 34px;
          height: 19px;
          flex-shrink: 0;
        }

        .sim-switch input {
          position: absolute;
          width: 1px;
          height: 1px;
          opacity: 0;
          pointer-events: none;
        }

        .sim-switch-track {
          position: absolute;
          inset: 0;
          border-radius: 999px;
          background: #CBD5E1;
          cursor: pointer;
          transition: background .18s ease;
        }

        .sim-switch-track::after {
          content: "";
          position: absolute;
          top: 3px;
          left: 3px;
          width: 13px;
          height: 13px;
          border-radius: 50%;
          background: #FFFFFF;
          box-shadow: 0 1px 3px rgba(15, 23, 42, .22);
          transition: transform .18s ease;
        }

        .sim-switch input:checked + .sim-switch-track {
          background: #2F73C9;
        }

        .sim-switch input:checked + .sim-switch-track::after {
          transform: translateX(15px);
        }

        .cal-box {
          margin-top: 12px;
          padding: 11px;
          border: 1px solid #DCE8F5;
          border-radius: 11px;
          background: #F8FBFF;
        }

        .cal-title {
          color: #1F67DA;
          font-size: 11px;
          font-weight: 900;
        }

        .cal-selector {
          display: grid;
          grid-template-columns:
            repeat(2, 1fr);
          gap: 5px;
          margin-top: 8px;
        }

        .cal-selector button {
          padding: 6px;
          border: 1px solid #D7E3F3;
          border-radius: 7px;
          background: #FFFFFF;
          color: #334155;
          font-size: 9px;
          font-weight: 800;
          cursor: pointer;
        }

        .cal-selector button.active {
          border-color: #2367D9;
          background: #2367D9;
          color: #FFFFFF;
        }

        .cal-grid {
          display: grid;
          grid-template-columns:
            repeat(4, 1fr);
          gap: 5px;
          margin-top: 8px;
        }

        .cal-grid label {
          color: #6B7D93;
          font-size: 8px;
          font-weight: 800;
        }

        .cal-grid input {
          width: 100%;
          margin-top: 2px;
          padding: 5px;
          border: 1px solid #D6E1EC;
          border-radius: 6px;
          font-size: 9px;
        }

        .cal-actions {
          display: flex;
          gap: 6px;
          margin-top: 8px;
        }

        .cal-actions button {
          flex: 1;
          padding: 7px;
          border-radius: 7px;
          font-size: 9px;
          font-weight: 900;
          cursor: pointer;
        }

        .cal-reset {
          border: 1px solid #D6E1EC;
          background: #FFFFFF;
          color: #475569;
        }

        .cal-save {
          border: 0;
          background: #2367D9;
          color: #FFFFFF;
        }

        .cal-json-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 7px;
          margin-top: 8px;
        }

        .cal-json-head span {
          color: #6B7F96;
          font-size: 8px;
        }

        .cal-copy {
          padding: 5px 8px;
          border: 1px solid #B8D4F4;
          border-radius: 6px;
          background: #FFFFFF;
          color: #1263D3;
          font-size: 8px;
          font-weight: 900;
          cursor: pointer;
        }

        .cal-json {
          width: 100%;
          height: 110px;
          margin-top: 6px;
          padding: 7px;
          resize: vertical;
          border: 1px solid #D6E1EC;
          border-radius: 7px;
          background: #0F172A;
          color: #DBEAFE;
          font-family:
            "Courier New",
            monospace;
          font-size: 8px;
          line-height: 1.35;
        }

        .cal-overlay {
          fill: rgba(
            0,
            155,
            255,
            .10
          );
          stroke: #00A0FF;
          stroke-width: 3;
          stroke-dasharray: 10 7;
          cursor: move;
        }

        .cal-overlay.active {
          fill: rgba(
            255,
            180,
            0,
            .14
          );
          stroke: #FF9800;
        }

        .cal-handle {
          fill: #FFFFFF;
          stroke: #FF9800;
          stroke-width: 3;
          cursor: nwse-resize;
        }

        /*
         * Desktop:
         * evita scroll de la página.
         * Si el panel es más alto,
         * sólo scrollea el panel.
         */
        @media (min-width: 901px) {
          html,
          body {
            overflow: hidden;
          }

          .sim-page {
            height: 100vh;
            overflow: hidden;
          }

          .sim-device-area.sim-device-mobile-sticky {
            position: static;
          }
        }

        /*
         * Responsive:
         * en pantallas pequeñas sí permitimos
         * scroll natural para no cortar controles.
         */
        @media (max-width: 900px) {
          /*
           * MOBILE / TABLET
           * En móvil sí permitimos scroll natural de la página,
           * pero el cajero aparece inmediatamente después del selector.
           * El SVG conserva el mismo viewBox, por lo que todas las
           * calibraciones y animaciones se escalan proporcionalmente.
           */
          .sim-page {
            height: auto;
            min-height: 100vh;
            overflow-x: hidden;
            overflow-y: visible;
          }

          .sim-wrap {
            height: auto;
            display: block;
            padding: 10px;
          }

          /*
           * Cabecera mucho más compacta en móvil.
           */
          .sim-top {
            grid-template-columns: 104px minmax(0, 1fr);
            gap: 9px;
            min-height: 56px;
            padding: 7px 9px;
            border-radius: 14px;
          }

          .sim-brand-card {
            width: 104px;
            height: 40px;
            min-height: 0;
            padding: 5px 7px;
            justify-content: center;
            border-radius: 10px;
          }

          .sim-brand-card img {
            width: auto;
            max-width: 94px;
            max-height: 31px;
          }

          .sim-title h1 {
            font-size: 18px;
            line-height: 1.05;
          }

          .sim-title p {
            margin-top: 3px;
            white-space: normal;
            font-size: 9px;
            line-height: 1.3;
          }

          /*
           * Selector horizontal deslizable.
           * Evita que los cinco modelos ocupen 2 o 3 filas.
           */
          .sim-tabs-shell {
            margin-top: 8px;
            padding: 7px 4px;
            overflow: hidden;
            border-radius: 13px;
          }

          .sim-tabs-over-device {
            width: 100%;
            margin: 0;
            padding: 1px 6px 4px;
            transform: none;
            justify-content: flex-start;
            flex-wrap: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            scroll-snap-type: x proximity;
            scrollbar-width: none;
            -webkit-overflow-scrolling: touch;
          }

          .sim-tabs-over-device::-webkit-scrollbar {
            display: none;
          }

          .sim-tab {
            flex: 0 0 auto;
            min-width: 102px;
            padding: 8px 12px;
            font-size: 10px;
            scroll-snap-align: start;
          }

          /*
           * En móvil: primero cajero, después controles.
           */
          .sim-layout {
            grid-template-columns: 1fr;
            gap: 10px;
            margin-top: 8px;
            height: auto;
          }

          /*
           * El equipo ya no ocupa 540 px fijos.
           * Se limita a un tamaño cómodo para que se vea completo y
           * los controles queden mucho más cerca.
           */
          .sim-device-area {
            width: 100%;
            height: clamp(330px, 49vh, 410px);
            min-height: 330px;
            max-height: 410px;
            padding: 5px 8px;
            border-radius: 15px;
          }

          /*
           * Durante una simulación activa el cajero permanece visible
           * mientras el usuario baja a billetes y monedas.
           */
          .sim-device-area.sim-device-mobile-sticky {
            position: sticky;
            top: 6px;
            z-index: 30;
            height: clamp(270px, 38vh, 330px);
            min-height: 270px;
            max-height: 330px;
            margin-bottom: 2px;
            background:
              radial-gradient(
                circle at top,
                rgba(47, 115, 201, .08),
                transparent 38%
              ),
              #FFFFFF;
            box-shadow:
              0 10px 28px
              rgba(15, 23, 42, .14);
          }

          .sim-machine {
            width: 100%;
            height: 100%;
            max-height: 100%;
            max-width: 100%;
            object-fit: contain;
          }

          /*
           * Controles táctiles cómodos.
           */
          .sim-panel {
            height: auto;
            max-height: none;
            overflow: visible;
            padding: 13px;
            border-radius: 15px;
          }

          .sim-panel-head {
            margin-bottom: 7px;
          }

          .sim-panel-title {
            font-size: 17px;
          }

          .sim-panel-subtitle {
            font-size: 10px;
          }

          .sim-message {
            font-size: 11px;
          }

          .sim-summary {
            gap: 5px;
          }

          .sim-summary-card {
            padding: 7px 3px;
          }

          .sim-primary {
            min-height: 44px;
            font-size: 12px;
          }

          .sim-money {
            min-height: 46px;
          }

          .sim-coin {
            width: 50px;
            min-width: 50px;
          }

          .sim-cancel {
            min-height: 42px;
          }

          .sim-integration-row {
            margin-top: 18px;
          }

          .sim-integration-btn {
            min-height: 42px;
          }

          /*
           * El switch de calibración permanece discreto y accesible.
           */
          .sim-cal-access {
            left: 7px;
            bottom: 7px;
            transform: scale(.92);
            transform-origin: left bottom;
          }

          /*
           * Modal de integración adaptado a móvil.
           */
          .sim-integration-overlay {
            padding: 14px;
          }

          .sim-integration-modal {
            width: min(100%, 440px);
            border-radius: 20px;
          }

          .sim-integration-modal-top {
            min-height: 126px;
            padding: 23px 22px 19px;
          }

          .sim-integration-title {
            font-size: 23px;
          }

          .sim-integration-body {
            padding: 20px 22px 22px;
          }
        }

        @media (max-width: 480px) {
          .sim-wrap {
            padding: 8px;
          }

          .sim-top {
            grid-template-columns: 88px minmax(0, 1fr);
            gap: 7px;
            min-height: 52px;
            padding: 6px 8px;
          }

          .sim-brand-card {
            width: 88px;
            height: 36px;
            padding: 4px 5px;
          }

          .sim-brand-card img {
            max-width: 80px;
            max-height: 28px;
          }

          .sim-title h1 {
            font-size: 16px;
          }

          .sim-title p {
            font-size: 8.5px;
          }

          .sim-tabs-shell {
            margin-top: 6px;
          }

          .sim-tab {
            min-width: 96px;
            padding: 7px 10px;
            font-size: 9.5px;
          }

          .sim-layout {
            margin-top: 7px;
          }

          .sim-device-area {
            height: clamp(315px, 47vh, 375px);
            min-height: 315px;
            max-height: 375px;
          }

          .sim-device-area.sim-device-mobile-sticky {
            top: 4px;
            height: clamp(245px, 36vh, 285px);
            min-height: 245px;
            max-height: 285px;
            padding: 3px 6px;
            border-radius: 13px;
          }

          .sim-panel {
            padding: 11px;
          }

          .sim-panel-model {
            min-width: 65px;
            padding: 6px 8px;
            font-size: 9px;
          }

          .sim-status {
            padding: 6px 9px;
            font-size: 9px;
          }

          .sim-summary-card strong {
            font-size: 12px;
          }

          .sim-bills {
            grid-template-columns:
              repeat(3, 1fr);
            gap: 6px;
          }

          .sim-coins {
            gap: 6px;
          }

          .sim-coin {
            width: 48px;
            min-width: 48px;
          }
        }
      `}</style>

      <div className="sim-page">
        <div className="sim-wrap">
          <div className="sim-top">
            <div className="sim-brand-card">
              <img
                src={embeddedEmpaticaLogo}
                alt="Empática Soluciones"
              />
            </div>

            <div className="sim-title">
              <h1>
                Simulador de cajeros
              </h1>

              <p>
                Selecciona un modelo y simula en tiempo real el flujo de pago en efectivo.
              </p>
            </div>
          </div>

          <div className="sim-tabs-shell">
            <div className="sim-tabs sim-tabs-over-device">
              {ORDEN_MODELOS.map(
                (key) => MODELOS[key]
              ).map((item) => (
                <button
                  key={item.key}
                  type="button"
                  className={`sim-tab ${modeloActivo ===
                      item.key
                      ? "active"
                      : ""
                    }`}
                  disabled={!imagenesListas}
                  onClick={() =>
                    cambiarModelo(
                      item.key
                    )
                  }
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          <div className="sim-layout">
            {/* ================================================
                EQUIPO
            ================================================ */}
            <div
              className={`sim-device-area ${estado !== ESTADOS.ESPERANDO &&
                  !modoCalibracion
                  ? "sim-device-mobile-sticky"
                  : ""
                }`}
            >
              <svg
                ref={svgRef}
                className="sim-machine"
                viewBox={`0 0 ${modelo.viewW} ${modelo.viewH}`}
                preserveAspectRatio="xMidYMid meet"
              >
                <defs>
                  <filter
                    id="ledGlow"
                    x="-50%"
                    y="-100%"
                    width="200%"
                    height="300%"
                  >
                    <feGaussianBlur
                      stdDeviation="2.2"
                      result="blur"
                    />

                    <feMerge>
                      <feMergeNode in="blur" />
                      <feMergeNode
                        in="SourceGraphic"
                      />
                    </feMerge>
                  </filter>

                  <filter
                    id="blueGlow"
                    x="-150%"
                    y="-350%"
                    width="400%"
                    height="800%"
                  >
                    <feGaussianBlur
                      stdDeviation="6"
                      result="b1"
                    />

                    <feGaussianBlur
                      stdDeviation="10"
                      result="b2"
                    />

                    <feMerge>
                      <feMergeNode in="b2" />
                      <feMergeNode in="b1" />
                      <feMergeNode
                        in="SourceGraphic"
                      />
                    </feMerge>
                  </filter>

                  <filter
                    id="scannerGlow"
                    x="-120%"
                    y="-120%"
                    width="340%"
                    height="340%"
                  >
                    <feGaussianBlur
                      stdDeviation="4"
                      result="blur"
                    />

                    <feMerge>
                      <feMergeNode in="blur" />
                      <feMergeNode
                        in="SourceGraphic"
                      />
                    </feMerge>
                  </filter>

                  <linearGradient
                    id="billGradient"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="1"
                  >
                    <stop
                      offset="0%"
                      stopColor="#E8F2DF"
                    />

                    <stop
                      offset="100%"
                      stopColor="#A9CDA4"
                    />
                  </linearGradient>

                  <radialGradient
                    id="coinGradient"
                    cx="35%"
                    cy="30%"
                    r="70%"
                  >
                    <stop
                      offset="0%"
                      stopColor="#FFF4AE"
                    />

                    <stop
                      offset="62%"
                      stopColor="#D7AA2D"
                    />

                    <stop
                      offset="100%"
                      stopColor="#936B10"
                    />
                  </radialGradient>

                  {/* Recorte exacto de la pantalla SUNMI */}
                  {(modeloActivo ===
                    "e200" ||
                    modeloActivo ===
                    "e100" ||
                    modeloActivo ===
                    "e300" ||
                    (modeloActivo ===
                      "aps101" ||
                      modeloActivo ===
                      "aps301")) &&
                    zonas.display && (
                      <clipPath id="sunmiScreenClip">
                        <rect
                          x={
                            zonas
                              .display
                              .x
                          }
                          y={
                            zonas
                              .display
                              .y
                          }
                          width={
                            zonas
                              .display
                              .width
                          }
                          height={
                            zonas
                              .display
                              .height
                          }
                          rx="3"
                        />
                      </clipPath>
                    )}

                  {/* Ticket */}
                  {ticketData && (
                    <clipPath id="ticketClip">
                      <rect
                        x={
                          ticketData.x
                        }
                        y={
                          ticketData.slotBottom
                        }
                        width={
                          ticketData.width
                        }
                        height="220"
                      />
                    </clipPath>
                  )}
                </defs>

                {/* IMAGEN BASE - NUNCA SE MODIFICA */}
                {ORDEN_MODELOS.map(
                  (modeloKey) => {
                    const item =
                      MODELOS[modeloKey];

                    /*
                     * Todas las imágenes permanecen montadas dentro
                     * del SVG. Al cambiar de modelo sólo cambiamos
                     * opacity; React ya no destruye y vuelve a crear
                     * el <image>, evitando el retraso de 2-3 segundos
                     * observado en producción.
                     */
                    return (
                      <image
                        key={`cajero-cache-${item.key}`}
                        href={item.image}
                        x="0"
                        y="0"
                        width={item.viewW}
                        height={item.viewH}
                        preserveAspectRatio="xMidYMid meet"
                        opacity={
                          modeloActivo ===
                            item.key
                            ? 1
                            : 0
                        }
                        pointerEvents="none"
                      />
                    );
                  }
                )}

                {/* ==============================================
                    QUICKPAY MINI DISPLAY
                ============================================== */}
                {modeloActivo ===
                  "quickpayMini" &&
                  zonas.display && (
                    <text
                      x={
                        zonas.display.x +
                        zonas.display
                          .width /
                        2
                      }
                      y={
                        zonas.display.y +
                        zonas.display
                          .height /
                        2
                      }
                      fill="#FF6721"
                      fontFamily='"Courier New", monospace'
                      fontSize="28"
                      fontWeight="900"
                      textAnchor="middle"
                      dominantBaseline="middle"
                      letterSpacing="1.2"
                      filter="url(#ledGlow)"
                    >
                      {montoDisplay}
                    </text>
                  )}

                {/* ==============================================
                    E200 / E100 / E300 - INTERFAZ SUNMI HORIZONTAL
                ============================================== */}
                {(modeloActivo ===
                  "e200" ||
                  modeloActivo ===
                  "e100" ||
                  modeloActivo ===
                  "e300") &&
                  zonas.display && (
                    <g
                      clipPath="url(#sunmiScreenClip)"
                    >
                      <g
                        transform={`
                          translate(
                            ${zonas.display.x}
                            ${zonas.display.y}
                          )
                          scale(
                            ${zonas.display.width / 800}
                            ${zonas.display.height / 385}
                          )
                        `}
                      >
                        <SunmiScreen
                          estado={estado}
                          montoCuenta={
                            montoCuenta
                          }
                          montoIngresado={
                            montoIngresado
                          }
                          restante={
                            restante
                          }
                          cambio={cambio}
                          folio={
                            folio
                          }
                        />
                      </g>
                    </g>
                  )}

                {/* ==============================================
                    APS101 / APS301 - INTERFAZ VERTICAL NATIVA
                    420 x 760 -> pantalla física vertical
                ============================================== */}
                {(modeloActivo ===
                  "aps101" ||
                  modeloActivo ===
                  "aps301") &&
                  zonas.display && (
                    <g
                      clipPath="url(#sunmiScreenClip)"
                    >
                      <g
                        transform={`
                          translate(
                            ${zonas.display.x}
                            ${zonas.display.y}
                          )
                          scale(
                            ${zonas.display.width / 420}
                            ${zonas.display.height / 760}
                          )
                        `}
                      >
                        <Aps101Screen
                          estado={estado}
                          montoCuenta={
                            montoCuenta
                          }
                          montoIngresado={
                            montoIngresado
                          }
                          restante={
                            restante
                          }
                          cambio={cambio}
                          folio={
                            folio
                          }
                        />
                      </g>
                    </g>
                  )}

                {/* ==============================================
                    SCANNER
                ============================================== */}
                {estado ===
                  ESTADOS.ESCANEANDO &&
                  zonas.scanner && (
                    <rect
                      x={
                        zonas.scanner
                          .x - 3
                      }
                      y={
                        zonas.scanner
                          .y - 3
                      }
                      width={
                        zonas.scanner
                          .width + 6
                      }
                      height={
                        zonas.scanner
                          .height + 6
                      }
                      rx="6"
                      fill="none"
                      stroke="#23C5FF"
                      strokeWidth="4"
                      filter="url(#scannerGlow)"
                    >
                      <animate
                        attributeName="opacity"
                        values=".25;1;.25"
                        dur="1.05s"
                        repeatCount="indefinite"
                      />
                    </rect>
                  )}

                {/* ==============================================
                    BILLETERO HABILITADO
                ============================================== */}
                {pagoActivo &&
                  zonas.billetero && (
                    <>
                      <rect
                        x={
                          zonas.billetero
                            .x - 6
                        }
                        y={
                          zonas.billetero
                            .y - 5
                        }
                        width={
                          zonas.billetero
                            .width +
                          12
                        }
                        height={
                          zonas.billetero
                            .height +
                          10
                        }
                        rx="5"
                        fill="rgba(0,165,255,.07)"
                        stroke="#00AAFF"
                        strokeWidth="2"
                        filter="url(#blueGlow)"
                      >
                        <animate
                          attributeName="opacity"
                          values=".45;1;.45"
                          dur="1.2s"
                          repeatCount="indefinite"
                        />
                      </rect>

                      <rect
                        x={
                          zonas.billetero
                            .x + 1
                        }
                        y={
                          zonas.billetero
                            .y + 1
                        }
                        width={Math.max(
                          zonas
                            .billetero
                            .width - 2,
                          1
                        )}
                        height={Math.max(
                          zonas
                            .billetero
                            .height - 2,
                          1
                        )}
                        rx="3"
                        fill="rgba(0,190,255,.28)"
                      />
                    </>
                  )}

                {/* ==============================================
                    BILLETE ENTRANDO
                ============================================== */}
                {billeteAnimacion !==
                  null &&
                  billeteVisual && (
                    <g
                      opacity={
                        billeteVisual.opacity
                      }
                      transform={`
                        translate(
                          0
                          ${billeteVisual.y *
                        (1 -
                          billeteVisual.scaleY)
                        }
                        )
                        scale(
                          1
                          ${billeteVisual.scaleY}
                        )
                      `}
                    >
                      <rect
                        x={
                          billeteVisual.x
                        }
                        y={
                          billeteVisual.y
                        }
                        width={
                          billeteVisual.width
                        }
                        height={
                          billeteVisual.height
                        }
                        rx="5"
                        fill="url(#billGradient)"
                        stroke="#5B7E60"
                        strokeWidth="2"
                      />

                      <circle
                        cx={
                          billeteVisual.x +
                          24
                        }
                        cy={
                          billeteVisual.y +
                          billeteVisual
                            .height /
                          2
                        }
                        r="13"
                        fill="none"
                        stroke="#55755A"
                        strokeWidth="2"
                      />

                      <text
                        x={
                          billeteVisual.x +
                          24
                        }
                        y={
                          billeteVisual.y +
                          billeteVisual
                            .height /
                          2 +
                          5
                        }
                        textAnchor="middle"
                        fill="#47664E"
                        fontSize="15"
                        fontWeight="900"
                      >
                        $
                      </text>

                      <text
                        x={
                          billeteVisual.x +
                          billeteVisual
                            .width *
                          .66
                        }
                        y={
                          billeteVisual.y +
                          billeteVisual
                            .height /
                          2 +
                          6
                        }
                        textAnchor="middle"
                        fill="#31513A"
                        fontSize="20"
                        fontWeight="900"
                      >
                        {
                          billeteAnimacion
                        }
                      </text>
                    </g>
                  )}

                {/* ==============================================
                    MONEDA ENTRANDO
                ============================================== */}
                {monedaAnimacion !==
                  null &&
                  monedaVisual && (
                    <g
                      opacity={
                        monedaVisual.opacity
                      }
                      transform={`
                        translate(
                          ${monedaVisual.cx}
                          ${monedaVisual.cy}
                        )
                        scale(
                          1
                          ${monedaVisual.scaleY}
                        )
                        translate(
                          ${-monedaVisual.cx}
                          ${-monedaVisual.cy}
                        )
                      `}
                    >
                      <circle
                        cx={
                          monedaVisual.cx
                        }
                        cy={
                          monedaVisual.cy
                        }
                        r={
                          monedaVisual.r
                        }
                        fill="url(#coinGradient)"
                        stroke="#876412"
                        strokeWidth="3"
                      />

                      <text
                        x={
                          monedaVisual.cx
                        }
                        y={
                          monedaVisual.cy +
                          5
                        }
                        textAnchor="middle"
                        fill="#5C430D"
                        fontSize="12"
                        fontWeight="900"
                      >
                        $
                        {
                          monedaAnimacion
                        }
                      </text>
                    </g>
                  )}

                {/* ==============================================
                    TICKET SALIENDO
                ============================================== */}
                {ticketVisible &&
                  ticketData && (
                    <>
                      <g
                        clipPath="url(#ticketClip)"
                      >
                        <rect
                          x={
                            ticketData.x +
                            6
                          }
                          y={
                            ticketData.paperY
                          }
                          width={Math.max(
                            ticketData.width -
                            12,
                            35
                          )}
                          height={
                            ticketData.paperHeight
                          }
                          rx="2"
                          fill="#FFFFFF"
                          stroke="#D4D4D4"
                          strokeWidth="2"
                        />

                        <text
                          x={
                            ticketData.x +
                            ticketData
                              .width /
                            2
                          }
                          y={
                            ticketData.paperY +
                            23
                          }
                          textAnchor="middle"
                          fill="#111111"
                          fontSize={
                            modeloActivo ===
                              "e200"
                              ? "9"
                              : "11"
                          }
                          fontWeight="900"
                        >
                          {modeloActivo ===
                            "quickpayMini"
                            ? "QUICKPAY MINI"
                            : modeloActivo ===
                              "e100"
                              ? "E100"
                              : modeloActivo ===
                                "e300"
                                ? "E300"
                                : modeloActivo ===
                                  "aps101"
                                  ? "APS101"
                                  : modeloActivo ===
                                    "aps301"
                                    ? "APS301"
                                    : "E200"}
                        </text>

                        <text
                          x={
                            ticketData.x +
                            ticketData
                              .width /
                            2
                          }
                          y={
                            ticketData.paperY +
                            43
                          }
                          textAnchor="middle"
                          fill="#222222"
                          fontSize="8"
                          fontWeight="700"
                        >
                          PAGO REALIZADO
                        </text>

                        <text
                          x={
                            ticketData.x +
                            14
                          }
                          y={
                            ticketData.paperY +
                            66
                          }
                          fill="#222222"
                          fontSize="7"
                        >
                          TOTAL
                        </text>

                        <text
                          x={
                            ticketData.x +
                            ticketData
                              .width -
                            14
                          }
                          y={
                            ticketData.paperY +
                            66
                          }
                          textAnchor="end"
                          fill="#222222"
                          fontSize="7"
                          fontWeight="700"
                        >
                          $
                          {montoCuenta.toFixed(
                            2
                          )}
                        </text>
                      </g>

                      {/* Boca por encima del papel */}
                      <rect
                        x={
                          ticketData.x
                        }
                        y={
                          ticketData.y
                        }
                        width={
                          ticketData.width
                        }
                        height={
                          ticketData.height
                        }
                        rx="3"
                        fill="rgba(5,7,9,.92)"
                      />

                      <rect
                        x={
                          ticketData.x +
                          10
                        }
                        y={
                          ticketData.y +
                          Math.max(
                            ticketData.height /
                            2 -
                            2,
                            2
                          )
                        }
                        width={Math.max(
                          ticketData.width -
                          20,
                          15
                        )}
                        height="4"
                        rx="2"
                        fill="#010203"
                      />
                    </>
                  )}

                {/* ==============================================
                    CAMBIO QUICKPAY MINI / E100 / E200 / E300 / APS
                ============================================== */}
                {cambioVisible &&
                  (modeloActivo ===
                    "quickpayMini" ||
                    modeloActivo ===
                    "e200" ||
                    modeloActivo ===
                    "e100" ||
                    modeloActivo ===
                    "e300" ||
                    modeloActivo ===
                    "aps101" ||
                    modeloActivo ===
                    "aps301") && (
                    <>
                      {/* Billetes de cambio */}
                      {((modeloActivo ===
                        "quickpayMini" &&
                        zonas.billetero) ||
                        (modeloActivo ===
                          "e200" &&
                          zonas.cambioBilletes) ||
                        (modeloActivo ===
                          "e100" &&
                          zonas.billetero) ||
                        (modeloActivo ===
                          "e300" &&
                          zonas.cambioBilletes) ||
                        ((modeloActivo ===
                          "aps101" ||
                          modeloActivo ===
                          "aps301") &&
                          zonas.billetero)) && (
                          <g>
                            <rect
                              x={
                                modeloActivo ===
                                  "e200" ||
                                  modeloActivo ===
                                  "e300"
                                  ? zonas
                                    .cambioBilletes
                                    .x + 18
                                  : modeloActivo ===
                                    "quickpayMini"
                                    ? zonas
                                      .billetero
                                      .x + 18
                                    : modeloActivo ===
                                      "e100"
                                      ? zonas
                                        .billetero
                                        .x + 18
                                      : zonas
                                        .billetero
                                        .x + 12
                              }
                              y={
                                modeloActivo ===
                                  "e200" ||
                                  modeloActivo ===
                                  "e300"
                                  ? zonas
                                    .cambioBilletes
                                    .y + 10
                                  : modeloActivo ===
                                    "quickpayMini"
                                    ? zonas
                                      .billetero
                                      .y + 12
                                    : modeloActivo ===
                                      "e100"
                                      ? zonas
                                        .billetero
                                        .y + 12
                                      : zonas
                                        .billetero
                                        .y + 8
                              }
                              width={
                                modeloActivo ===
                                  "e200" ||
                                  modeloActivo ===
                                  "e300"
                                  ? Math.max(
                                    zonas
                                      .cambioBilletes
                                      .width - 36,
                                    45
                                  )
                                  : modeloActivo ===
                                    "quickpayMini"
                                    ? Math.max(
                                      zonas
                                        .billetero
                                        .width - 36,
                                      55
                                    )
                                    : modeloActivo ===
                                      "e100"
                                      ? Math.max(
                                        zonas
                                          .billetero
                                          .width - 36,
                                        45
                                      )
                                      : Math.max(
                                        zonas
                                          .billetero
                                          .width - 24,
                                        45
                                      )
                              }
                              height={
                                modeloActivo ===
                                  "aps101"
                                  ? 18
                                  : modeloActivo ===
                                    "quickpayMini"
                                    ? 28
                                    : 30
                              }
                              rx="4"
                              fill="#C9DFC5"
                              stroke="#64805F"
                              strokeWidth="2"
                            >
                              <animate
                                attributeName="opacity"
                                values="0;1;1;0"
                                dur="1.3s"
                                repeatCount="indefinite"
                              />
                            </rect>
                          </g>
                        )}

                      {/* Monedas de cambio */}
                      {zonas.cambioMonedas &&
                        [
                          -28,
                          0,
                          28,
                        ].map(
                          (
                            dx,
                            index
                          ) => (
                            <circle
                              key={
                                index
                              }
                              cx={
                                zonas
                                  .cambioMonedas
                                  .x +
                                zonas
                                  .cambioMonedas
                                  .width /
                                2 +
                                dx
                              }
                              cy={
                                modeloActivo ===
                                  "aps101"
                                  ? zonas
                                    .cambioMonedas
                                    .y + 82
                                  : modeloActivo ===
                                    "quickpayMini"
                                    ? zonas
                                      .cambioMonedas
                                      .y +
                                    Math.min(
                                      zonas
                                        .cambioMonedas
                                        .height /
                                      2,
                                      52
                                    )
                                    : zonas
                                      .cambioMonedas
                                      .y + 30
                              }
                              r="15"
                              fill="url(#coinGradient)"
                              stroke="#876412"
                              strokeWidth="2"
                            >
                              <animate
                                attributeName="opacity"
                                values="0;1;0"
                                dur="1.1s"
                                begin={`${index *
                                  .15}s`}
                                repeatCount="indefinite"
                              />
                            </circle>
                          )
                        )}
                    </>
                  )}

                {/* ==============================================
                    CALIBRACIÓN
                ============================================== */}
                {modoCalibracion &&
                  clavesCalibracion.map(
                    ({
                      key,
                    }) => {
                      const z =
                        zonas[key];

                      if (!z) {
                        return null;
                      }

                      const active =
                        elementoActivo ===
                        key;

                      return (
                        <g key={key}>
                          <rect
                            x={
                              z.x
                            }
                            y={
                              z.y
                            }
                            width={
                              z.width
                            }
                            height={
                              z.height
                            }
                            rx="3"
                            className={`cal-overlay ${active
                                ? "active"
                                : ""
                              }`}
                            onMouseDown={(
                              e
                            ) =>
                              iniciarDrag(
                                e,
                                key,
                                "mover"
                              )
                            }
                          />

                          {active && (
                            <rect
                              x={
                                z.x +
                                z.width -
                                10
                              }
                              y={
                                z.y +
                                z.height -
                                10
                              }
                              width="20"
                              height="20"
                              rx="3"
                              className="cal-handle"
                              onMouseDown={(
                                e
                              ) =>
                                iniciarDrag(
                                  e,
                                  key,
                                  "resize"
                                )
                              }
                            />
                          )}
                        </g>
                      );
                    }
                  )}
              </svg>
            </div>

            {/* ================================================
                PANEL CONTROL
            ================================================ */}
            <div className="sim-panel">
              <div className="sim-panel-head">
                <div>
                  <div className="sim-panel-kicker">
                    Panel de simulación
                  </div>

                  <div className="sim-panel-title">
                    {modelo.label}
                  </div>

                  <div className="sim-panel-subtitle">
                    Sigue el flujo de cobro,
                    ingreso de efectivo y
                    entrega final del ticket.
                  </div>
                </div>

                <div className="sim-panel-model">
                  {modelo.label}
                </div>
              </div>

              <div className="sim-status">
                {modoCalibracion
                  ? `CALIBRANDO ${modelo.label.toUpperCase()}`
                  : estado.replaceAll(
                    "_",
                    " "
                  )}
              </div>

              <div className="sim-message">
                {modoCalibracion
                  ? "Arrastra cada zona sobre la pieza real del equipo. La interfaz SUNMI quedará limitada exactamente a la zona Pantalla SUNMI."
                  : mensaje}
              </div>

              {!modoCalibracion && (
                <>
                  <div className="sim-summary">
                    <div className="sim-summary-card">
                      <span>
                        TOTAL
                      </span>

                      <strong>
                        $
                        {montoCuenta.toFixed(
                          2
                        )}
                      </strong>
                    </div>

                    <div className="sim-summary-card">
                      <span>
                        INGRESADO
                      </span>

                      <strong>
                        $
                        {montoIngresado.toFixed(
                          2
                        )}
                      </strong>
                    </div>

                    <div className="sim-summary-card">
                      <span>
                        {cambio >
                          0
                          ? "CAMBIO"
                          : "RESTANTE"}
                      </span>

                      <strong>
                        $
                        {(
                          cambio > 0
                            ? cambio
                            : restante
                        ).toFixed(2)}
                      </strong>
                    </div>
                  </div>

                  {estado ===
                    ESTADOS.ESPERANDO && (
                      <button
                        type="button"
                        className="sim-primary"
                        onClick={
                          escanearQR
                        }
                      >
                        Simular escaneo QR
                      </button>
                    )}

                  {estado ===
                    ESTADOS.PAGADO && (
                      <button
                        type="button"
                        className="sim-primary sim-secondary-return"
                        onClick={
                          reiniciar
                        }
                      >
                        Volver al inicio
                      </button>
                    )}

                  {pagoActivo && (
                    <>
                      <div className="sim-section">
                        <div className="sim-section-title">
                          Billetes
                        </div>

                        <div className="sim-section-help">
                          {modeloActivo ===
                            "quickpayMini"
                            ? "Se simula la entrada por el billetero del QuickPay Mini."
                            : modeloActivo ===
                              "e100"
                              ? "En el E100 los billetes entran por el billetero frontal y por esa misma salida se entrega el cambio de billetes."
                              : modeloActivo ===
                                "aps101"
                                ? "En el APS101 los billetes entran por el billetero frontal y por ese mismo punto se devuelve el cambio de billetes."
                                : modeloActivo ===
                                  "aps301"
                                  ? "En el APS301 los billetes entran por el billetero frontal y por ese mismo punto se devuelve el cambio de billetes."
                                  : "Se simula la entrada por el billetero superior izquierdo del E200."}
                        </div>

                        <div className="sim-bills">
                          {BILLETES.map(
                            (
                              value
                            ) => (
                              <button
                                type="button"
                                key={
                                  value
                                }
                                className="sim-money"
                                disabled={
                                  dineroEnMovimiento
                                }
                                onClick={() =>
                                  ingresarBillete(
                                    value
                                  )
                                }
                              >
                                $
                                {
                                  value
                                }
                              </button>
                            )
                          )}
                        </div>
                      </div>

                      <div className="sim-section">
                        <div className="sim-section-title">
                          Monedas
                        </div>

                        <div className="sim-section-help">
                          {modeloActivo ===
                            "quickpayMini"
                            ? "Se simula la entrada por la ranura superior del QuickPay Mini."
                            : modeloActivo ===
                              "e100"
                              ? "Se simula la entrada de monedas por la charola superior derecha del E100."
                              : modeloActivo ===
                                "aps101"
                                ? "Se simula la entrada de monedas por el receptáculo del APS101."
                                : modeloActivo ===
                                  "aps301"
                                  ? "Se simula la entrada de monedas por el receptáculo superior derecho del APS301."
                                  : "Se simula la entrada por la parte superior derecha del E200."}
                        </div>

                        <div className="sim-coins">
                          {MONEDAS.map(
                            (
                              value
                            ) => (
                              <button
                                type="button"
                                key={
                                  value
                                }
                                className="sim-coin"
                                disabled={
                                  dineroEnMovimiento
                                }
                                onClick={() =>
                                  ingresarMoneda(
                                    value
                                  )
                                }
                              >
                                $
                                {
                                  value
                                }
                              </button>
                            )
                          )}
                        </div>
                      </div>

                      <button
                        type="button"
                        className="sim-cancel"
                        onClick={
                          cancelarOperacion
                        }
                      >
                        Cancelar operación
                      </button>
                    </>
                  )}
                </>
              )}

              {mostrarBotonCalibracion && (
                <button
                  type="button"
                  className="sim-cal-toggle"
                  onClick={() =>
                    setModoCalibracion(
                      (
                        current
                      ) =>
                        !current
                    )
                  }
                >
                  {modoCalibracion
                    ? "Cerrar calibración"
                    : "Calibrar posiciones"}
                </button>
              )}

              {mostrarBotonCalibracion && modoCalibracion && (
                <div className="cal-box">
                  <div className="cal-title">
                    {modelo.label}
                  </div>

                  <div className="cal-selector">
                    {clavesCalibracion.map(
                      ({
                        key,
                        label,
                      }) => (
                        <button
                          key={
                            key
                          }
                          type="button"
                          className={
                            elementoActivo ===
                              key
                              ? "active"
                              : ""
                          }
                          onClick={() =>
                            setElementoActivo(
                              key
                            )
                          }
                        >
                          {
                            label
                          }
                        </button>
                      )
                    )}
                  </div>

                  <div className="cal-grid">
                    <label>
                      X
                      <input
                        type="number"
                        value={Math.round(
                          actual.x
                        )}
                        onChange={(
                          e
                        ) =>
                          actualizarCampo(
                            elementoActivo,
                            "x",
                            e
                              .target
                              .value
                          )
                        }
                      />
                    </label>

                    <label>
                      Y
                      <input
                        type="number"
                        value={Math.round(
                          actual.y
                        )}
                        onChange={(
                          e
                        ) =>
                          actualizarCampo(
                            elementoActivo,
                            "y",
                            e
                              .target
                              .value
                          )
                        }
                      />
                    </label>

                    <label>
                      Ancho
                      <input
                        type="number"
                        value={Math.round(
                          actual.width
                        )}
                        onChange={(
                          e
                        ) =>
                          actualizarCampo(
                            elementoActivo,
                            "width",
                            e
                              .target
                              .value
                          )
                        }
                      />
                    </label>

                    <label>
                      Alto
                      <input
                        type="number"
                        value={Math.round(
                          actual.height
                        )}
                        onChange={(
                          e
                        ) =>
                          actualizarCampo(
                            elementoActivo,
                            "height",
                            e
                              .target
                              .value
                          )
                        }
                      />
                    </label>
                  </div>

                  <div className="cal-actions">
                    <button
                      type="button"
                      className="cal-reset"
                      onClick={
                        restaurarCalibracion
                      }
                    >
                      Restaurar
                    </button>

                    <button
                      type="button"
                      className="cal-save"
                      onClick={
                        guardarCalibracion
                      }
                    >
                      Guardar
                    </button>
                  </div>

                  <div className="cal-json-head">
                    <span>
                      Calibración actual
                    </span>

                    <button
                      type="button"
                      className="cal-copy"
                      onClick={
                        copiarCalibracion
                      }
                    >
                      Copiar
                    </button>
                  </div>

                  <textarea
                    className="cal-json"
                    value={
                      calibracionJson
                    }
                    readOnly
                    spellCheck={
                      false
                    }
                  />
                </div>
              )}

              {!modoCalibracion && (
                <div className="sim-integration-row">
                  <button
                    type="button"
                    className="sim-integration-btn"
                    onClick={() =>
                      setMostrarIntegracion(
                        true
                      )
                    }
                  >
                    <span className="sim-integration-dot" />
                    Prueba tu integración
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {mostrarIntegracion && (
          <div
            className="sim-integration-overlay"
            role="presentation"
            onMouseDown={(event) => {
              if (
                event.target ===
                event.currentTarget
              ) {
                setMostrarIntegracion(
                  false
                );
              }
            }}
          >
            <div
              className="sim-integration-modal"
              role="dialog"
              aria-modal="true"
              aria-label="Prueba tu integración"
            >
              <div className="sim-integration-modal-top">
                <button
                  type="button"
                  className="sim-integration-x"
                  aria-label="Cerrar"
                  onClick={() =>
                    setMostrarIntegracion(
                      false
                    )
                  }
                >
                  ×
                </button>

                <div className="sim-integration-badge">
                  NUEVA FUNCIÓN
                </div>

                <div className="sim-integration-title">
                  Prueba tu integración
                </div>
              </div>

              <div className="sim-integration-body">
                <p>
                  Estamos preparando una nueva
                  herramienta para que puedas
                  probar cómo se comunicaría tu
                  sistema con nuestros cajeros
                  antes de llevar la integración
                  a producción.
                </p>

                <div className="sim-integration-coming">
                  <div className="sim-integration-coming-icon">
                    &lt;/&gt;
                  </div>

                  <div>
                    <strong>
                      Función en desarrollo
                    </strong>

                    <span>
                      Muy pronto podrás realizar
                      pruebas de integración
                      directamente desde este
                      simulador.
                    </span>
                  </div>
                </div>

                <button
                  type="button"
                  className="sim-integration-close"
                  onClick={() =>
                    setMostrarIntegracion(
                      false
                    )
                  }
                >
                  Entendido
                </button>
              </div>
            </div>
          </div>
        )}

        {/*
        <div
          className="sim-cal-access"
          title="Mostrar u ocultar acceso a calibración"
        >
          <span className="sim-cal-access-label">
            Calibración
          </span>

          <label className="sim-switch">
            <input
              type="checkbox"
              checked={mostrarBotonCalibracion}
              onChange={(event) => {
                const visible =
                  event.target.checked;

                setMostrarBotonCalibracion(
                  visible
                );

                if (!visible) {
                  setModoCalibracion(false);
                }
              }}
              aria-label="Mostrar botón de calibración"
            />

            <span className="sim-switch-track" />
          </label>
        </div>*/}


      </div>
    </>
  );
};


  return EmbeddedCashierCore;
})();

const EcosistemaPos = () => {
  const [dispositivo, setDispositivo] = useState("tablet-horizontal");
  const [vistaMovil, setVistaMovil] = useState(false);
  const [conectado, setConectado] = useState(false);
  const [modo, setModo] = useState("POS");
  const [flujo, setFlujo] = useState("QR");
  const [carrito, setCarrito] = useState([]);
  const [montoCalc, setMontoCalc] = useState("");
  const [operacion, setOperacion] = useState(null);
  const [mostrarCajero, setMostrarCajero] = useState(false);
  const [disparadorCajero, setDisparadorCajero] = useState(0);
  const [carritoAbierto, setCarritoAbierto] = useState(false);
  const [cajeroKey, setCajeroKey] = useState(0);
  const [modeloCajero, setModeloCajero] = useState("E100");
  const cashierWrapRef = useRef(null);
  const pagoDetectadoRef = useRef(false);

  const subtotal = useMemo(
    () => carrito.reduce((acc, item) => acc + item.precio * item.qty, 0),
    [carrito]
  );

  // El cajero trabaja con importes enteros: si hay centavos, se cobra el entero inmediato superior.
  const total = conectado ? Math.ceil(subtotal) : subtotal;

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const media = window.matchMedia("(max-width: 760px)");
    const aplicarVista = (coincide) => {
      setVistaMovil(coincide);
      if (coincide) {
        setDispositivo("movil-vertical");
      }
    };

    aplicarVista(media.matches);

    const onChange = (event) => aplicarVista(event.matches);
    if (media.addEventListener) media.addEventListener("change", onChange);
    else media.addListener(onChange);

    return () => {
      if (media.removeEventListener) media.removeEventListener("change", onChange);
      else media.removeListener(onChange);
    };
  }, []);

  useEffect(() => {
    if (!conectado) {
      setModo("POS");
      setFlujo("QR");
      setMostrarCajero(false);
      setOperacion(null);
    }
  }, [conectado]);

  useEffect(() => {
    setOperacion(null);
    setMostrarCajero(false);
  }, [flujo, modo]);

  useEffect(() => {
    if (modo === "CALCULADORA" && flujo !== "DIRECTO") {
      setFlujo("DIRECTO");
    }
  }, [modo, flujo]);


  useEffect(() => {
    setCarritoAbierto(false);
  }, [dispositivo, modo]);

  // SimuladorCajero.js usa estilos globales cuando trabaja como página completa.
  // Aquí garantizamos que /ecosistemapos mantenga su scroll vertical.
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const liberar = () => {
      html.style.setProperty("overflow-y", "auto", "important");
      body.style.setProperty("overflow-y", "auto", "important");
      html.style.setProperty("overflow-x", "hidden", "important");
      body.style.setProperty("overflow-x", "hidden", "important");
    };
    liberar();
    const raf = requestAnimationFrame(liberar);
    const timer = setTimeout(liberar, 80);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(timer);
    };
  }, [operacion, disparadorCajero]);

  // Detecta el final o cancelación dentro de SimuladorCajero.js sin modificar ese archivo.
  // Cancelación: cierra la ventana a los 2 segundos y conserva la venta para reintentar.
  // Pago exitoso: espera 5 segundos, cierra la ventana y reinicia toda la venta.
  useEffect(() => {
    if (!conectado || !mostrarCajero) return undefined;
    const root = cashierWrapRef.current;
    if (!root) return undefined;

    pagoDetectadoRef.current = false;
    let closeTimer = null;

    const revisarEstado = () => {
      if (pagoDetectadoRef.current) return;
      const texto = (root.textContent || "").replace(/\s+/g, " ").trim();

      const completado = /Pago exitoso|Pago completado correctamente|Transacción exitosa/i.test(texto);
      const cancelado = /Operación cancelada|CANCELADO/i.test(texto);

      if (completado) {
        pagoDetectadoRef.current = true;
        closeTimer = window.setTimeout(() => {
          setCarrito([]);
          setMontoCalc("");
          setOperacion(null);
          setMostrarCajero(false);
          setDisparadorCajero(0);
          setModo("POS");
          setFlujo("QR");
          setCarritoAbierto(false);
          setCajeroKey((prev) => prev + 1);
        }, 5000);
        return;
      }

      if (cancelado) {
        pagoDetectadoRef.current = true;
        closeTimer = window.setTimeout(() => {
          setMostrarCajero(false);
          setDisparadorCajero(0);
          setCajeroKey((prev) => prev + 1);
        }, 2000);
      }
    };

    const observer = new MutationObserver(revisarEstado);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    revisarEstado();

    return () => {
      observer.disconnect();
      if (closeTimer) window.clearTimeout(closeTimer);
    };
  }, [conectado, mostrarCajero, cajeroKey]);

  useEffect(() => {
    if (!mostrarCajero) return;
    const timer = window.setTimeout(() => {
      const root = cashierWrapRef.current;
      if (!root) return;
      const tabs = Array.from(root.querySelectorAll(".sim-tab"));
      const objetivo = tabs.find((tab) => (tab.textContent || "").trim() === modeloCajero);
      if (objetivo && !objetivo.className.includes("active")) objetivo.click();
    }, 160);
    return () => window.clearTimeout(timer);
  }, [mostrarCajero, modeloCajero, cajeroKey]);

  const add = (product) => {
    setCarrito((prev) => {
      const existe = prev.find((item) => item.id === product.id);
      if (existe) {
        return prev.map((item) =>
          item.id === product.id ? { ...item, qty: item.qty + 1 } : item
        );
      }
      return [...prev, { ...product, qty: 1 }];
    });
  };

  const qty = (id, diff) => {
    setCarrito((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, qty: Math.max(1, item.qty + diff) } : item
      )
    );
  };

  const remove = (id) => setCarrito((prev) => prev.filter((item) => item.id !== id));

  const crearOperacion = (tipo, monto) => {
    const folio = generarFolio();
    const items =
      tipo === "POS"
        ? carrito.map((item) => ({ nombre: item.nombre, precio: item.precio, qty: item.qty }))
        : [{ nombre: "Cobro manual", precio: monto, qty: 1 }];

    return {
      folio,
      fecha: new Date().toLocaleString("es-MX"),
      tipo,
      items,
      total: monto,
      qrPayload: `empaticapos|folio=${folio}|monto=${Number(monto).toFixed(2)}|tipo=${tipo}`,
    };
  };

  const iniciarCajeroDesdePos = () => {
    // El simulador embebido arranca únicamente con disparadorExterno
    // y utiliza operacion.total; no hay click sintético ni monto demo.
  };

  const abrirSimulacion = () => {
    setMostrarCajero(true);
    window.setTimeout(() => {
      setDisparadorCajero((prev) => prev + 1);
      iniciarCajeroDesdePos();
    }, 650);
  };

  const enviarDirecto = (nuevaOperacion) => {
    setOperacion(nuevaOperacion);
    abrirSimulacion();
  };

  const procesarPOS = () => {
    if (total <= 0) return;
    const nueva = crearOperacion("POS", total);

    if (!conectado) {
      setOperacion(nueva);
      setMostrarCajero(false);
      return;
    }

    if (flujo === "DIRECTO") {
      enviarDirecto(nueva);
    } else {
      setOperacion(nueva);
      setMostrarCajero(false);
    }
  };

  const procesarCalculadora = () => {
    const monto = Math.trunc(Number(montoCalc || 0));
    if (!conectado || monto <= 0) return;
    const nueva = crearOperacion("CALCULADORA", monto);
    enviarDirecto(nueva);
  };

  const simularEscaneoQr = () => {
    if (!operacion || flujo !== "QR") return;
    abrirSimulacion();
  };

  const reiniciar = () => {
    setModo("POS");
    setFlujo("QR");
    setCarrito([]);
    setMontoCalc("");
    setOperacion(null);
    setMostrarCajero(false);
    setDisparadorCajero(0);
    setCarritoAbierto(false);
    setCajeroKey((prev) => prev + 1);
  };

  return (
    <>
      <style>{`
        * { box-sizing: border-box; }
        html, body { margin: 0; overflow-x: hidden !important; overflow-y: auto !important; background: #f5f7fb; }

        .ep-page {
          min-height: 100vh;
          background: #f5f7fb;
          color: #0f172a;
          font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        }
        .ep-inner { width: min(1500px, calc(100% - 28px)); margin: 0 auto; padding: 18px 0 44px; }
        .ep-top {
          display: flex; justify-content: space-between; align-items: center; gap: 12px;
          flex-wrap: wrap; margin-bottom: 12px;
        }
        .ep-title { font-size: 25px; font-weight: 900; }
        .ep-title span { color: #155eef; }
        .ep-top-actions { display: flex; gap: 9px; flex-wrap: wrap; align-items: center; }

        .ep-segment {
          display: inline-flex; gap: 4px; padding: 4px; background: #eaf0f9; border-radius: 999px;
        }
        .ep-segment button, .ep-mode-switch button {
          border: 0; background: transparent; border-radius: 999px; padding: 9px 14px;
          font-weight: 900; color: #475569; cursor: pointer;
        }
        .ep-segment button.active { background: #155eef; color: #fff; box-shadow: 0 6px 16px rgba(21,94,239,.18); }
        .ep-secondary, .ep-primary {
          border: 0; border-radius: 13px; padding: 11px 15px; font-weight: 900; cursor: pointer;
        }
        .ep-secondary { background: #fff; border: 1px solid #dbe3f0; color: #334155; }
        .ep-primary { background: #155eef; color: #fff; }
        .ep-primary:disabled { opacity: .45; cursor: not-allowed; }
        .full { width: 100%; }

        .ep-card {
          background: #fff; border: 1px solid #e5e7eb; border-radius: 20px;
          box-shadow: 0 16px 38px rgba(15,23,42,.05);
        }

        .ep-device-selector {
          background: #fff; border: 1px solid #e5e7eb; border-radius: 18px;
          padding: 10px 12px; margin-bottom: 12px; display: flex; align-items: center;
          gap: 12px; flex-wrap: wrap;
        }
        .ep-device-selector-label { font-size: 14px; font-weight: 900; white-space: nowrap; }
        .ep-device-options { display: flex; gap: 7px; flex-wrap: wrap; }
        .ep-device-option {
          border: 1px solid #dbe3f0; background: #fff; border-radius: 12px; padding: 7px 10px;
          display: flex; align-items: center; gap: 7px; cursor: pointer; font-size: 12px; font-weight: 800;
          color: #334155;
        }
        .ep-device-option.active { border-color: #155eef; background: #f4f8ff; color: #155eef; }
        .ep-device-icon { font-size: 22px; line-height: 1; }
        .ep-device-icon.tablet-horizontal { transform: scaleX(1.35); }
        .ep-device-icon.movil-vertical { font-size: 18px; }

        .ep-workspace { display: grid; grid-template-columns: minmax(0, 1fr) 500px; gap: 14px; align-items: start; }
        .ep-left-card, .ep-payment-card { padding: 15px; }
        .ep-section-title { font-size: 18px; font-weight: 900; margin-bottom: 4px; }
        .ep-help { color: #64748b; font-size: 13px; line-height: 1.45; margin-bottom: 12px; }

        .ep-device-shell {
          margin: 0 auto; background: #1769b5; border-radius: 25px; padding: 12px;
          box-shadow: 0 18px 38px rgba(23,105,181,.18); transition: width .2s ease;
        }
        .ep-device-shell.tablet-h { width: min(100%, 820px); }
        .ep-device-shell.tablet-v { width: min(100%, 470px); }
        .ep-device-shell.mobile-v { width: min(100%, 315px); border-radius: 30px; }
        .ep-device-toolbar {
          min-height: 40px; display: flex; align-items: center; justify-content: flex-start;
          gap: 8px; color: #fff; padding: 0 4px 9px; flex-wrap: wrap;
        }
        .ep-pos-config-bar {
          display: flex; align-items: center; justify-content: flex-start; gap: 14px; flex-wrap: wrap;
          width: 100%; margin: 0 0 14px; padding: 10px 12px;
          background: #f8fbff; border: 1px solid #dbe7f5; border-radius: 14px;
        }
        .ep-pos-config-group { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
        .ep-pos-config-label {
          font-size: 11px; font-weight: 900; color: #64748b; text-transform: uppercase; letter-spacing: .04em;
        }
        .ep-config-switch {
          display: inline-flex; gap: 3px; padding: 3px; background: #eaf0f7; border-radius: 999px;
        }
        .ep-config-switch button {
          border: 0; background: transparent; border-radius: 999px; padding: 7px 11px;
          color: #475569; font-size: 11px; font-weight: 900; cursor: pointer;
        }
        .ep-config-switch button.active { background: #1769b5; color: #fff; box-shadow: 0 3px 10px rgba(23,105,181,.18); }
        .ep-pos-config-separator { width: 1px; height: 28px; background: #dbe3ee; }
        .ep-device-screen { background: #fff; border-radius: 17px; overflow: visible; height: auto !important; min-height: 0 !important; }
        /* La altura del dispositivo la determina su contenido.
           Sin recortes, sin scroll interno y sin espacio vacío adicional. */
        .ep-device-shell.tablet-h .ep-device-screen,
        .ep-device-shell.tablet-v .ep-device-screen,
        .ep-device-shell.mobile-v .ep-device-screen { min-height: 0; }

        .ep-pos-screen { display: grid; grid-template-columns: 1.35fr .78fr; height: auto !important; min-height: 0 !important; align-items: stretch; }
        .ep-catalog { padding: 14px; display: grid; grid-template-rows: auto auto auto; gap: 9px; overflow: visible; align-content: start; align-self: stretch; min-height: 0 !important; }
        .ep-search { border: 1px solid #e5e7eb; background: #f8fafc; color: #94a3b8; border-radius: 11px; padding: 10px 12px; }
        .ep-categories { display: flex; flex-wrap: wrap; gap: 5px; }
        .ep-categories span { padding: 6px 8px; background: #f1f5f9; border-radius: 999px; font-size: 11px; font-weight: 800; color: #475569; }
        .ep-categories span.active { background: #155eef; color: #fff; }
        .ep-products { display: grid; grid-template-columns: repeat(auto-fill,minmax(100px,1fr)); gap: 8px; align-content: start; }
        .ep-product { border: 1px solid #e5e7eb; background: #fff; border-radius: 13px; padding: 10px; cursor: pointer; text-align: left; color: #0f172a; }
        .ep-product:hover { border-color: #155eef; }
        .ep-product-emoji { display: block; font-size: 25px; margin-bottom: 6px; }
        .ep-product strong { display: block; font-size: 12px; }
        .ep-product small { display: block; color: #64748b; margin-top: 3px; }

        .ep-device-shell.tablet-h .ep-device-screen {
          height: 430px !important;
          overflow: hidden;
        }
        .ep-device-shell.tablet-h .ep-pos-screen {
          grid-template-columns: 1.35fr .78fr;
          height: 430px !important;
          min-height: 430px !important;
          align-items: stretch;
        }
        .ep-device-shell.tablet-h .ep-catalog {
          height: 100% !important;
          min-height: 0 !important;
          display: grid;
          grid-template-rows: auto auto minmax(0, 1fr);
          align-content: stretch;
          overflow: hidden;
        }
        .ep-device-shell.tablet-h .ep-products {
          grid-template-columns: repeat(4, minmax(0, 1fr));
          min-height: 0;
          overflow-y: auto;
          align-content: start;
          padding-right: 2px;
        }
        .ep-device-shell.tablet-h .ep-cart {
          align-self: stretch;
          height: 100% !important;
          min-height: 0 !important;
          overflow: hidden;
        }
        .ep-device-shell.tablet-h .ep-cart-items {
          flex: 1 1 auto;
          min-height: 0;
          overflow-y: auto;
          overscroll-behavior: contain;
        }
        .ep-device-shell.tablet-h .ep-cart-total {
          margin-top: auto;
          flex: 0 0 auto;
        }
        .ep-device-shell.tablet-h .ep-primary.full {
          margin-top: 2px;
          flex: 0 0 auto;
        }

        /* En vertical/móvil el carrito es un bottom sheet real.
           El catálogo permanece visible y el carrito no empuja los productos. */
        .ep-device-shell.tablet-v .ep-pos-screen,
        .ep-device-shell.mobile-v .ep-pos-screen {
          position: relative;
          display: block;
          min-height: 0;
          overflow: hidden;
          padding-bottom: 0;
        }
        /* En vertical el botón del carrito SIEMPRE queda visible abajo.
           Buscador y categorías permanecen fijos; solo productos hacen scroll si hace falta. */
        .ep-device-shell.tablet-v .ep-pos-screen { height: 610px !important; }
        .ep-device-shell.mobile-v .ep-pos-screen { height: 590px !important; }
        .ep-device-shell.tablet-v .ep-catalog,
        .ep-device-shell.mobile-v .ep-catalog {
          height: 100% !important;
          display: grid;
          grid-template-rows: auto auto minmax(0, 1fr);
          overflow: hidden;
          padding-bottom: 62px;
          align-content: stretch;
        }
        .ep-device-shell.tablet-v .ep-products,
        .ep-device-shell.mobile-v .ep-products {
          min-height: 0;
          overflow-y: auto;
          overscroll-behavior: contain;
          align-content: start;
          padding-right: 2px;
        }
        .ep-device-shell.tablet-v .ep-products { grid-template-columns: repeat(3, 1fr); gap: 7px; }
        .ep-device-shell.tablet-v .ep-product { padding: 8px; }
        .ep-device-shell.tablet-v .ep-product-emoji { font-size: 22px; margin-bottom: 4px; }
        .ep-device-shell.mobile-v .ep-catalog { padding: 10px; gap: 7px; }
        .ep-device-shell.mobile-v .ep-search { padding: 8px 10px; font-size: 12px; }
        .ep-device-shell.mobile-v .ep-categories span { padding: 5px 6px; font-size: 10px; }
        .ep-device-shell.mobile-v .ep-products { grid-template-columns: repeat(2, 1fr); gap: 6px; }
        .ep-device-shell.mobile-v .ep-product { padding: 7px; border-radius: 11px; }
        .ep-device-shell.mobile-v .ep-product-emoji { font-size: 20px; margin-bottom: 3px; }
        .ep-device-shell.mobile-v .ep-product strong { font-size: 11px; }
        .ep-device-shell.mobile-v .ep-product small { font-size: 10px; }

        .ep-cart { border-left: 1px solid #e5e7eb; padding: 13px; display: flex; flex-direction: column; min-height: 0 !important; height: auto !important; overflow: visible; align-self: start; }
        .ep-cart.bottom-sheet {
          position: absolute;
          left: 0; right: 0; bottom: 0;
          z-index: 8;
          border-left: 0;
          border-top: 1px solid #dbe3f0;
          background: #fff;
          border-radius: 18px 18px 0 0;
          box-shadow: 0 -16px 36px rgba(15,23,42,.18);
          transform: translateY(calc(100% + 8px));
          opacity: 0;
          pointer-events: none;
          transition: transform .24s ease, opacity .2s ease;
          max-height: 82%;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
        .ep-cart.bottom-sheet.open {
          transform: translateY(0);
          opacity: 1;
          pointer-events: auto;
        }
        .ep-sheet-handle { width: 44px; height: 4px; border-radius: 999px; background: #cbd5e1; margin: 0 auto 9px; }
        .ep-cart-title-actions { display: flex; align-items: center; gap: 8px; }
        .ep-sheet-close {
          width: 28px; height: 28px; border-radius: 999px; border: 1px solid #dbe3f0;
          background: #fff; color: #475569; font-size: 18px; cursor: pointer; line-height: 1;
        }
        .ep-sheet-backdrop {
          position: absolute; inset: 0; z-index: 7; border: 0; margin: 0; padding: 0;
          background: rgba(15,23,42,.18); cursor: pointer;
        }
        .ep-cart-trigger {
          position: absolute; left: 10px; right: 10px; bottom: 8px; z-index: 6;
          display: flex; align-items: center; justify-content: space-between; gap: 10px;
          border: 0; border-radius: 13px; padding: 11px 13px; background: #155eef; color: #fff;
          font-weight: 900; cursor: pointer; box-shadow: 0 8px 18px rgba(21,94,239,.22);
        }
        .ep-device-shell.mobile-v .ep-cart.bottom-sheet { padding: 10px; max-height: 86%; }
        .ep-cart.bottom-sheet .ep-cart-items { flex: 1 1 auto; min-height: 0; overflow-y: auto; overscroll-behavior: contain; }
        .ep-cart.bottom-sheet .ep-cart-total,
        .ep-cart.bottom-sheet .ep-primary.full { flex: 0 0 auto; }
        .ep-device-shell.mobile-v .ep-cart-total { font-size: 15px; padding: 9px 0; }
        .ep-cart-title { display: flex; justify-content: space-between; gap: 8px; padding-bottom: 9px; border-bottom: 1px solid #eef2f7; }
        .ep-cart-title span { color: #64748b; font-size: 11px; }
        .ep-cart-items { flex: none; display: grid; align-content: start; gap: 7px; padding-top: 9px; }
        .ep-cart-item { display: grid; grid-template-columns: 1fr auto; gap: 6px; border: 1px solid #edf1f6; background: #fbfdff; border-radius: 11px; padding: 8px; }
        .ep-cart-item strong { display: block; font-size: 12px; }
        .ep-cart-item small { color: #64748b; font-size: 11px; }
        .ep-qty { display: flex; align-items: center; gap: 4px; }
        .ep-qty button { width: 24px; height: 24px; border: 1px solid #dbe3f0; background: #fff; border-radius: 7px; cursor: pointer; }
        .ep-qty .remove { color: #dc2626; font-weight: 900; }
        .ep-cart-total { display: flex; justify-content: space-between; border-top: 1px solid #e5e7eb; padding: 12px 0; font-size: 18px; }

        .ep-calc-screen { display: grid; grid-template-columns: 1fr .7fr; height: 430px; min-height: 430px; overflow: hidden; }
        .ep-calc-main, .ep-calc-side { padding: 14px 18px; min-height: 0; }
        .ep-calc-main { display: flex; flex-direction: column; }
        .ep-calc-label { color: #64748b; margin-bottom: 5px; }
        .ep-calc-display { border: 1px solid #e5e7eb; background: #f8fafc; border-radius: 15px; padding: 13px 17px; font-size: 34px; font-weight: 900; margin-bottom: 10px; }
        .ep-keypad { display: grid; grid-template-columns: repeat(3,1fr); grid-template-rows: repeat(4, minmax(0, 1fr)); gap: 8px; flex: 1; min-height: 0; }
        .ep-keypad button { border: 1px solid #dbe3f0; background: #fff; border-radius: 13px; padding: 0; min-height: 0; font-size: 19px; font-weight: 900; cursor: pointer; }
        .ep-keypad button.zero { grid-column: 1 / span 2; }
        .ep-keypad button.back { grid-column: 3; }
        .ep-calc-side { border-left: 1px solid #e5e7eb; display: flex; flex-direction: column; justify-content: space-between; gap: 12px; }
        .ep-device-shell.tablet-v .ep-calc-screen,
        .ep-device-shell.mobile-v .ep-calc-screen { grid-template-columns: 1fr; }
        .ep-device-shell.tablet-v .ep-calc-side,
        .ep-device-shell.mobile-v .ep-calc-side { border-left: 0; border-top: 1px solid #e5e7eb; }
        .ep-device-shell.mobile-v .ep-calc-main,
        .ep-device-shell.mobile-v .ep-calc-side { padding: 12px; }
        .ep-device-shell.mobile-v .ep-keypad button { padding: 10px 0; }
        .ep-calc-side h3 { margin: 0 0 5px; }
        .ep-calc-side p { color: #64748b; line-height: 1.5; }

        .ep-payment-type { margin-bottom: 14px; }
        .ep-payment-type .ep-segment { display: flex; width: 100%; }
        .ep-payment-type .ep-segment button { flex: 1; }
        .ep-direct-info { border: 1px dashed #9fc4ff; background: #f4f8ff; color: #334155; border-radius: 15px; padding: 16px; text-align: center; }
        .ep-direct-info strong { display: block; color: #155eef; font-size: 26px; margin-top: 7px; }
        .ep-direct-sent { border: 1px solid #bbf7d0; background: #f0fdf4; color: #166534; border-radius: 15px; padding: 15px; text-align: center; font-weight: 800; }

        .ep-ticket-paper { max-width: 305px; margin: 0 auto; border: 1px dashed #cbd5e1; border-radius: 14px; padding: 14px; font-family: ui-monospace,SFMono-Regular,Menlo,monospace; }
        .ep-ticket-paper.compact-qr { max-width: 215px; padding: 11px; }
        .ep-ticket-center { text-align: center; font-size: 11px; }
        .ep-ticket-brand { font-size: 14px; font-weight: 900; }
        .ep-ticket-paper.compact-qr .ep-ticket-brand { font-size: 12px; }
        .ep-ticket-line { border-top: 1px dashed #cbd5e1; margin: 10px 0; }
        .ep-ticket-paper.compact-qr .ep-ticket-line { margin: 8px 0; }
        .ep-ticket-row, .ep-ticket-item { display: flex; justify-content: space-between; gap: 9px; font-size: 11px; margin-bottom: 5px; }
        .ep-ticket-paper.compact-qr .ep-ticket-row { font-size: 10px; margin-bottom: 4px; }
        .ep-ticket-row.total { font-size: 14px; }
        .ep-ticket-paid { text-align: center; color: #16a34a; font-weight: 900; }
        .ep-ticket-code { word-break: break-all; text-align: center; color: #64748b; font-size: 8px; }
        .ep-qr-wrap { width: 135px; margin: 10px auto; padding: 7px; border: 1px solid #e5e7eb; background: #fff; border-radius: 9px; }
        .ep-ticket-paper.compact-qr .ep-qr-wrap { width: 120px; margin: 8px auto 2px; padding: 6px; }
        .ep-qr-svg { width: 100%; height: auto; display: block; image-rendering: pixelated; }
        .ep-scan-btn { margin-top: 12px; }
        .ep-empty { display: grid; place-items: center; text-align: center; min-height: 160px; border: 1px dashed #cfd8e6; background: #f8fbff; color: #64748b; border-radius: 14px; padding: 15px; }
        .ep-empty.compact { min-height: 75px; }

        .ep-cashier-card { margin-top: 12px; padding-top: 12px; border-top: 1px solid #e5e7eb; }
        .ep-cashier-head { display: flex; justify-content: space-between; gap: 8px; align-items: center; flex-wrap: wrap; margin-bottom: 8px; }
        .ep-cashier-head .ep-section-title { font-size: 16px; margin: 0; }
        .ep-cashier-amount { background: #eef4ff; color: #155eef; border-radius: 999px; padding: 6px 10px; font-size: 12px; font-weight: 900; }
        .ep-cashier-selector-box { border: 1px solid #e5e7eb; background: #fbfdff; border-radius: 14px; padding: 10px; }
        .ep-model-scroll { display: flex; gap: 10px; overflow-x: auto; overflow-y: hidden; padding: 2px 1px 6px; }
        .ep-model-card {
          position: relative; flex: 0 0 118px; border: 1px solid #dbe3f0; background: #fff; color: #334155;
          border-radius: 14px; padding: 8px; cursor: pointer; text-align: center; transition: .16s ease;
        }
        .ep-model-card:hover { transform: translateY(-1px); border-color: #9fc4ff; }
        .ep-model-card.active { border-color: #155eef; box-shadow: 0 0 0 2px rgba(21,94,239,.10); background: #f7faff; }
        .ep-model-image-wrap { height: 86px; display: grid; place-items: center; overflow: hidden; border-radius: 10px; background: #f8fafc; }
        .ep-model-image { max-width: 100%; max-height: 82px; object-fit: contain; display: block; }
        .ep-model-card-label { margin-top: 7px; font-size: 11px; font-weight: 900; white-space: nowrap; }
        .ep-model-selected { margin-top: 3px; color: #155eef; font-size: 9px; font-weight: 900; }

        .ep-cashier-modal-overlay {
          position: fixed; inset: 0; z-index: 300; background: rgba(15,23,42,.52);
          display: flex; align-items: center; justify-content: center; padding: 22px;
          backdrop-filter: blur(5px);
        }
        .ep-cashier-modal {
          width: min(1120px, 100%); max-height: min(92vh, 980px); overflow: hidden;
          background: #fff; border-radius: 22px; border: 1px solid rgba(255,255,255,.45);
          box-shadow: 0 28px 80px rgba(15,23,42,.32); display: flex; flex-direction: column;
        }
        .ep-cashier-modal-top {
          display: flex; justify-content: space-between; align-items: flex-start; gap: 12px;
          padding: 16px 18px 12px; border-bottom: 1px solid #e5e7eb;
        }
        .ep-cashier-modal-title { font-size: 22px; font-weight: 900; }
        .ep-cashier-modal-sub { color: #64748b; font-size: 13px; margin-top: 3px; }
        .ep-modal-close {
          width: 36px; height: 36px; border-radius: 999px; border: 1px solid #dbe3f0; background: #fff; color: #334155;
          font-size: 24px; line-height: 1; cursor: pointer;
        }
        .ep-cashier-modal-body { padding: 14px 18px 12px; overflow: auto; }
        .ep-cashier-modal-foot { padding: 0 18px 16px; color: #64748b; font-size: 12px; }

        .ep-modal-cashier {
          border: 1px solid #e5e7eb; background: #fbfdff; border-radius: 16px; padding: 10px; overflow: hidden;
        }
        .ep-modal-cashier .sim-page {
          width: 100% !important; height: auto !important; min-height: 0 !important; overflow: visible !important; background: transparent !important;
        }
        .ep-modal-cashier .sim-wrap {
          width: 100% !important; max-width: none !important; height: auto !important; min-height: 0 !important;
          padding: 0 !important; display: flex !important; flex-direction: column !important; gap: 10px !important;
        }
        .ep-modal-cashier .sim-top,
        .ep-modal-cashier .sim-header { display: none !important; }
        .ep-modal-cashier .sim-tabs-shell,
        .ep-modal-cashier .sim-tabs,
        .ep-modal-cashier .sim-tabs-over-device,
        .ep-modal-cashier .sim-primary:not(.sim-secondary-return) { display: none !important; }
        .ep-modal-cashier .sim-layout {
          display: grid !important; grid-template-columns: minmax(360px, 1fr) minmax(320px, 420px) !important; gap: 16px !important;
          width: 100% !important; height: auto !important; min-height: 0 !important; align-items: start !important;
        }
        .ep-modal-cashier .sim-device-area {
          width: 100% !important; min-height: 500px !important; height: 500px !important; max-height: 500px !important;
          padding: 10px !important; border-radius: 14px !important; overflow: hidden !important; box-shadow: none !important;
        }
        .ep-modal-cashier .sim-machine {
          width: auto !important; max-width: 100% !important; height: 480px !important; max-height: 480px !important; margin: 0 auto !important;
        }
        .ep-modal-cashier .sim-panel {
          width: 100% !important; height: auto !important; min-height: 0 !important; max-height: none !important;
          overflow: visible !important; padding: 10px !important; border-radius: 14px !important;
          box-shadow: none !important; background: #fff !important;
        }
        .ep-modal-cashier .sim-integration-row,
        .ep-modal-cashier .sim-integration-overlay,
        .ep-modal-cashier .sim-cal-toggle,
        .ep-modal-cashier .cal-box { display: none !important; }
        .ep-modal-cashier .sim-bills,
        .ep-modal-cashier .sim-coins {
          display: flex !important; flex-wrap: wrap !important; gap: 7px !important; overflow: visible !important;
          padding-left: 0 !important; padding-right: 0 !important;
        }
        .ep-modal-cashier .sim-money {
          padding-left: 14px !important;
          padding-right: 14px !important;
        }
        .ep-modal-cashier .sim-coin {
          width: 54px !important;
          min-width: 54px !important;
          padding-left: 8px !important;
          padding-right: 8px !important;
        }
        @media (max-width: 900px) {
          .ep-cashier-modal { width: min(96vw, 1120px); max-height: 94vh; }
          .ep-modal-cashier .sim-layout { grid-template-columns: 1fr !important; }
          .ep-modal-cashier .sim-device-area { height: 420px !important; min-height: 420px !important; max-height: 420px !important; }
          .ep-modal-cashier .sim-machine { height: 400px !important; max-height: 400px !important; }
        }

        @media (max-width: 1120px) {
          .ep-workspace { grid-template-columns: 1fr; }
          .ep-payment-card { order: 2; }
        }
        @media (max-width: 760px) {
          .ep-inner { width: calc(100% - 10px); padding-top: 10px; }
          .ep-top { align-items: center; }
          .ep-title { font-size: 20px; }
          .ep-left-card, .ep-payment-card { padding: 10px; border-radius: 16px; }
          .ep-workspace { gap: 10px; }
          .ep-device-toolbar { align-items: flex-start; }
          .ep-pos-config-bar { align-items: flex-start; gap: 8px; padding: 9px 10px; }
          .ep-pos-config-separator { display: none; }
          .ep-pos-config-group { flex: 1 1 100%; justify-content: space-between; }
          .ep-pos-screen, .ep-calc-screen { grid-template-columns: 1fr; }
          .ep-cart, .ep-calc-side { border-left: 0; border-top: 1px solid #e5e7eb; }
          .ep-device-selector { align-items: center; padding: 8px 10px; margin-bottom: 10px; }
          .ep-device-selector.mobile-only { justify-content: space-between; }
          .ep-device-selector.mobile-only .ep-device-options { width: auto; }
          .ep-device-selector.mobile-only .ep-device-option { opacity: 1; cursor: default; }
          .ep-device-options { width: 100%; }
          .ep-device-shell.mobile-v { width: min(100%, 340px); }
          .ep-payment-card { width: 100%; min-width: 0; }
          .ep-cashier-modal-overlay { padding: 8px; }
          .ep-cashier-modal { width: 100%; max-height: 96vh; border-radius: 16px; }
        }
      `}</style>

      <div className="ep-page">
        <div className="ep-inner">
          <div className="ep-top">
            <div className="ep-title">Simulador <span>Empática POS</span></div>
            <div className="ep-top-actions">
              <button type="button" className="ep-secondary" onClick={reiniciar}>Reiniciar</button>
            </div>
          </div>

          <SelectorDispositivo
            value={dispositivo}
            onChange={setDispositivo}
            soloMovil={vistaMovil}
          />

          <div className="ep-workspace">
            <div className="ep-card ep-left-card">
              <div className="ep-section-title">2. Punto de venta</div>
              <div className="ep-help">
                {conectado
                  ? "Selecciona el modo de operación y prueba el flujo con cajero."
                  : "Sin cajero funciona como punto de venta normal y solo muestra modo POS."}
              </div>

              <div className="ep-pos-config-bar">
                <div className="ep-pos-config-group">
                  <span className="ep-pos-config-label">Conexión</span>
                  <div className="ep-config-switch">
                    <button
                      type="button"
                      className={conectado ? "active" : ""}
                      onClick={() => setConectado(true)}
                    >
                      Con cajero
                    </button>
                    <button
                      type="button"
                      className={!conectado ? "active" : ""}
                      onClick={() => setConectado(false)}
                    >
                      Sin cajero
                    </button>
                  </div>
                </div>

                <div className="ep-pos-config-separator" />

                <div className="ep-pos-config-group">
                  <span className="ep-pos-config-label">Modo</span>
                  <div className="ep-config-switch">
                    <button
                      type="button"
                      className={modo === "POS" ? "active" : ""}
                      onClick={() => setModo("POS")}
                    >
                      POS
                    </button>
                    {conectado && (
                      <button
                        type="button"
                        className={modo === "CALCULADORA" ? "active" : ""}
                        onClick={() => setModo("CALCULADORA")}
                      >
                        CALCULADORA
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <DeviceShell
                dispositivo={dispositivo}
                conectado={conectado}
                setConectado={setConectado}
                modo={modo}
                setModo={setModo}
                flujo={flujo}
                carrito={carrito}
                total={total}
                onAdd={add}
                onQty={qty}
                onRemove={remove}
                onActionPos={procesarPOS}
                montoCalc={montoCalc}
                setMontoCalc={setMontoCalc}
                onActionCalc={procesarCalculadora}
                carritoAbierto={carritoAbierto}
                setCarritoAbierto={setCarritoAbierto}
              />
            </div>

            <aside className="ep-card ep-payment-card">
              <div className="ep-section-title">3. Cobro</div>

              {conectado ? (
                <>
                  {modo === "POS" ? (
                    <>
                      <div className="ep-help">Selecciona cómo se enviará el cobro al cajero.</div>
                      <div className="ep-payment-type">
                        <div className="ep-segment">
                          <button type="button" className={flujo === "QR" ? "active" : ""} onClick={() => setFlujo("QR")}>Ticket QR</button>
                          <button type="button" className={flujo === "DIRECTO" ? "active" : ""} onClick={() => setFlujo("DIRECTO")}>Pago directo</button>
                        </div>
                      </div>

                      {flujo === "QR" ? (
                        <>
                          <Ticket operacion={operacion} qr />
                          {operacion && (
                            <button type="button" className="ep-primary full ep-scan-btn" onClick={simularEscaneoQr}>
                              Simular escaneo QR · {money(operacion.total)}
                            </button>
                          )}
                        </>
                      ) : operacion ? (
                        <div className="ep-direct-sent">
                          Monto enviado directamente al cajero
                          <strong style={{ display: "block", fontSize: 25, marginTop: 7 }}>{money(operacion.total)}</strong>
                        </div>
                      ) : (
                        <div className="ep-direct-info">
                          No se genera ticket.
                          <strong>{money(total)}</strong>
                          Al confirmar desde POS, el monto se envía directamente al cajero.
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="ep-help">Calculadora envía el importe directamente al cajero.</div>
                      {operacion ? (
                        <div className="ep-direct-sent">
                          Monto enviado directamente al cajero
                          <strong style={{ display: "block", fontSize: 25, marginTop: 7 }}>{money(operacion.total)}</strong>
                        </div>
                      ) : (
                        <div className="ep-direct-info">
                          No se genera ticket QR.
                          <strong>{money(Math.trunc(Number(montoCalc || 0)))}</strong>
                          Captura el importe y presiona Enviar al cajero.
                        </div>
                      )}
                    </>
                  )}

                  <div className="ep-cashier-card">
                    <div className="ep-cashier-head">
                      <div>
                        <div className="ep-section-title">Cajero</div>
                        <div className="ep-help" style={{ marginBottom: 0 }}>
                          Selecciona el modelo. La simulación se abrirá en grande al usar Ticket QR o Enviar al cajero.
                        </div>
                      </div>
                      {operacion && (
                        <div className="ep-cashier-amount">Monto: {money(operacion.total)}</div>
                      )}
                    </div>

                    <div className="ep-cashier-selector-box">
                      <div className="ep-model-scroll">
                        {MODELOS_CAJERO.map((modelo) => (
                          <button
                            type="button"
                            key={modelo.key}
                            className={`ep-model-card ${modeloCajero === modelo.key ? "active" : ""}`}
                            onClick={() => setModeloCajero(modelo.key)}
                          >
                            <div className="ep-model-image-wrap">
                              <img src={modelo.image} alt={modelo.label} className="ep-model-image" />
                            </div>
                            <div className="ep-model-card-label">{modelo.label}</div>
                            {modeloCajero === modelo.key && <div className="ep-model-selected">Seleccionado</div>}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="ep-help">La venta se registra como una caja normal y genera su ticket desglosado.</div>
                  <Ticket operacion={operacion} qr={false} />
                </>
              )}
            </aside>
          </div>

          {conectado && mostrarCajero && operacion && (
            <div className="ep-cashier-modal-overlay" role="presentation" onMouseDown={(event) => {
              if (event.target === event.currentTarget) setMostrarCajero(false);
            }}>
              <div className="ep-cashier-modal" role="dialog" aria-modal="true" aria-label="Simulación de cajero">
                <div className="ep-cashier-modal-top">
                  <div>
                    <div className="ep-cashier-modal-title">Simulación de cajero</div>
                    <div className="ep-cashier-modal-sub">Modelo: {modeloCajero} · Monto: {money(operacion.total)}</div>
                  </div>
                  <button type="button" className="ep-modal-close" onClick={() => setMostrarCajero(false)} aria-label="Cerrar">×</button>
                </div>
                <div className="ep-cashier-modal-body">
                  <div className="ep-modal-cashier" ref={cashierWrapRef}>
                    <EmbeddedCashierSimulator
                      key={cajeroKey}
                      modeloInicial={MODELOS_CAJERO.find((m) => m.key === modeloCajero)?.simKey || "e100"}
                      montoInicial={operacion?.total ?? null}
                      flujoInicial={flujo}
                      disparadorExterno={disparadorCajero}
                    />
                  </div>
                </div>
                <div className="ep-cashier-modal-foot">Pago exitoso: reinicia la venta en 5 segundos. Cancelación: cierra esta ventana en 2 segundos.</div>
              </div>
            </div>
          )}

        </div>
      </div>
    </>
  );
};

export default EcosistemaPos;
